// THIS FILE WAS GENERATED BY A SCRIPT AND SHOULD NOT BE UPDATED MANUALLY

/** @since 6.0.0 */
export type MaterialIconFamily =
  | "outlined"
  | "rounded"
  | "sharp"
  | "filled"
  | "two-tone";

/** @since 6.0.0 */
export type MaterialIconName =
  | "10k"
  | "10mp"
  | "11mp"
  | "123"
  | "12mp"
  | "13mp"
  | "14mp"
  | "15mp"
  | "16mp"
  | "17mp"
  | "18_up_rating"
  | "18mp"
  | "19mp"
  | "1k"
  | "1k_plus"
  | "1x_mobiledata"
  | "20mp"
  | "21mp"
  | "22mp"
  | "23mp"
  | "24mp"
  | "2k"
  | "2k_plus"
  | "2mp"
  | "30fps"
  | "30fps_select"
  | "360"
  | "3d_rotation"
  | "3g_mobiledata"
  | "3k"
  | "3k_plus"
  | "3mp"
  | "3p"
  | "4g_mobiledata"
  | "4g_plus_mobiledata"
  | "4k"
  | "4k_plus"
  | "4mp"
  | "5g"
  | "5k"
  | "5k_plus"
  | "5mp"
  | "60fps"
  | "60fps_select"
  | "6_ft_apart"
  | "6k"
  | "6k_plus"
  | "6mp"
  | "7k"
  | "7k_plus"
  | "7mp"
  | "8k"
  | "8k_plus"
  | "8mp"
  | "9k"
  | "9k_plus"
  | "9mp"
  | "abc"
  | "ac_unit"
  | "access_alarm"
  | "access_alarms"
  | "access_time"
  | "access_time_filled"
  | "accessibility"
  | "accessibility_new"
  | "accessible"
  | "accessible_forward"
  | "account_balance"
  | "account_balance_wallet"
  | "account_box"
  | "account_circle"
  | "account_tree"
  | "ad_units"
  | "adb"
  | "add"
  | "add_a_photo"
  | "add_alarm"
  | "add_alert"
  | "add_box"
  | "add_business"
  | "add_call"
  | "add_card"
  | "add_chart"
  | "add_circle"
  | "add_circle_outline"
  | "add_comment"
  | "add_home"
  | "add_home_work"
  | "add_ic_call"
  | "add_link"
  | "add_location"
  | "add_location_alt"
  | "add_moderator"
  | "add_photo_alternate"
  | "add_reaction"
  | "add_road"
  | "add_shopping_cart"
  | "add_task"
  | "add_to_drive"
  | "add_to_home_screen"
  | "add_to_photos"
  | "add_to_queue"
  | "addchart"
  | "adf_scanner"
  | "adjust"
  | "admin_panel_settings"
  | "ads_click"
  | "agriculture"
  | "air"
  | "airline_seat_flat"
  | "airline_seat_flat_angled"
  | "airline_seat_individual_suite"
  | "airline_seat_legroom_extra"
  | "airline_seat_legroom_normal"
  | "airline_seat_legroom_reduced"
  | "airline_seat_recline_extra"
  | "airline_seat_recline_normal"
  | "airline_stops"
  | "airlines"
  | "airplane_ticket"
  | "airplanemode_active"
  | "airplanemode_inactive"
  | "airplay"
  | "airport_shuttle"
  | "alarm"
  | "alarm_add"
  | "alarm_off"
  | "alarm_on"
  | "album"
  | "align_horizontal_center"
  | "align_horizontal_left"
  | "align_horizontal_right"
  | "align_vertical_bottom"
  | "align_vertical_center"
  | "align_vertical_top"
  | "all_inbox"
  | "all_inclusive"
  | "all_out"
  | "alt_route"
  | "alternate_email"
  | "analytics"
  | "anchor"
  | "android"
  | "animation"
  | "announcement"
  | "aod"
  | "apartment"
  | "api"
  | "app_blocking"
  | "app_registration"
  | "app_settings_alt"
  | "app_shortcut"
  | "approval"
  | "apps"
  | "apps_outage"
  | "architecture"
  | "archive"
  | "area_chart"
  | "arrow_back"
  | "arrow_back_ios"
  | "arrow_back_ios_new"
  | "arrow_circle_down"
  | "arrow_circle_left"
  | "arrow_circle_right"
  | "arrow_circle_up"
  | "arrow_downward"
  | "arrow_drop_down"
  | "arrow_drop_down_circle"
  | "arrow_drop_up"
  | "arrow_forward"
  | "arrow_forward_ios"
  | "arrow_left"
  | "arrow_outward"
  | "arrow_right"
  | "arrow_right_alt"
  | "arrow_upward"
  | "art_track"
  | "article"
  | "aspect_ratio"
  | "assessment"
  | "assignment"
  | "assignment_add"
  | "assignment_ind"
  | "assignment_late"
  | "assignment_return"
  | "assignment_returned"
  | "assignment_turned_in"
  | "assist_walker"
  | "assistant"
  | "assistant_direction"
  | "assistant_navigation"
  | "assistant_photo"
  | "assured_workload"
  | "atm"
  | "attach_email"
  | "attach_file"
  | "attach_money"
  | "attachment"
  | "attractions"
  | "attribution"
  | "audio_file"
  | "audiotrack"
  | "auto_awesome"
  | "auto_awesome_mosaic"
  | "auto_awesome_motion"
  | "auto_delete"
  | "auto_fix_high"
  | "auto_fix_normal"
  | "auto_fix_off"
  | "auto_graph"
  | "auto_mode"
  | "auto_stories"
  | "autofps_select"
  | "autorenew"
  | "av_timer"
  | "baby_changing_station"
  | "back_hand"
  | "backpack"
  | "backspace"
  | "backup"
  | "backup_table"
  | "badge"
  | "bakery_dining"
  | "balance"
  | "balcony"
  | "ballot"
  | "bar_chart"
  | "barcode_reader"
  | "batch_prediction"
  | "bathroom"
  | "bathtub"
  | "battery_0_bar"
  | "battery_1_bar"
  | "battery_20"
  | "battery_2_bar"
  | "battery_30"
  | "battery_3_bar"
  | "battery_4_bar"
  | "battery_50"
  | "battery_5_bar"
  | "battery_60"
  | "battery_6_bar"
  | "battery_80"
  | "battery_90"
  | "battery_alert"
  | "battery_charging_20"
  | "battery_charging_30"
  | "battery_charging_50"
  | "battery_charging_60"
  | "battery_charging_80"
  | "battery_charging_90"
  | "battery_charging_full"
  | "battery_full"
  | "battery_saver"
  | "battery_std"
  | "battery_unknown"
  | "beach_access"
  | "bed"
  | "bedroom_baby"
  | "bedroom_child"
  | "bedroom_parent"
  | "bedtime"
  | "bedtime_off"
  | "beenhere"
  | "bento"
  | "bike_scooter"
  | "biotech"
  | "blender"
  | "blind"
  | "blinds"
  | "blinds_closed"
  | "block"
  | "block_flipped"
  | "bloodtype"
  | "bluetooth"
  | "bluetooth_audio"
  | "bluetooth_connected"
  | "bluetooth_disabled"
  | "bluetooth_drive"
  | "bluetooth_searching"
  | "blur_circular"
  | "blur_linear"
  | "blur_off"
  | "blur_on"
  | "bolt"
  | "book"
  | "book_online"
  | "bookmark"
  | "bookmark_add"
  | "bookmark_added"
  | "bookmark_border"
  | "bookmark_remove"
  | "bookmarks"
  | "border_all"
  | "border_bottom"
  | "border_clear"
  | "border_color"
  | "border_horizontal"
  | "border_inner"
  | "border_left"
  | "border_outer"
  | "border_right"
  | "border_style"
  | "border_top"
  | "border_vertical"
  | "boy"
  | "branding_watermark"
  | "breakfast_dining"
  | "brightness_1"
  | "brightness_2"
  | "brightness_3"
  | "brightness_4"
  | "brightness_5"
  | "brightness_6"
  | "brightness_7"
  | "brightness_auto"
  | "brightness_high"
  | "brightness_low"
  | "brightness_medium"
  | "broadcast_on_home"
  | "broadcast_on_personal"
  | "broken_image"
  | "browse_gallery"
  | "browser_not_supported"
  | "browser_updated"
  | "brunch_dining"
  | "brush"
  | "bubble_chart"
  | "bug_report"
  | "build"
  | "build_circle"
  | "bungalow"
  | "burst_mode"
  | "bus_alert"
  | "business"
  | "business_center"
  | "cabin"
  | "cable"
  | "cached"
  | "cake"
  | "calculate"
  | "calendar_month"
  | "calendar_today"
  | "calendar_view_day"
  | "calendar_view_month"
  | "calendar_view_week"
  | "call"
  | "call_end"
  | "call_made"
  | "call_merge"
  | "call_missed"
  | "call_missed_outgoing"
  | "call_received"
  | "call_split"
  | "call_to_action"
  | "camera"
  | "camera_alt"
  | "camera_enhance"
  | "camera_front"
  | "camera_indoor"
  | "camera_outdoor"
  | "camera_rear"
  | "camera_roll"
  | "cameraswitch"
  | "campaign"
  | "cancel"
  | "cancel_presentation"
  | "cancel_schedule_send"
  | "candlestick_chart"
  | "car_crash"
  | "car_rental"
  | "car_repair"
  | "card_giftcard"
  | "card_membership"
  | "card_travel"
  | "carpenter"
  | "cases"
  | "casino"
  | "cast"
  | "cast_connected"
  | "cast_for_education"
  | "castle"
  | "catching_pokemon"
  | "category"
  | "celebration"
  | "cell_tower"
  | "cell_wifi"
  | "center_focus_strong"
  | "center_focus_weak"
  | "chair"
  | "chair_alt"
  | "chalet"
  | "change_circle"
  | "change_history"
  | "charging_station"
  | "chat"
  | "chat_bubble"
  | "chat_bubble_outline"
  | "check"
  | "check_box"
  | "check_box_outline_blank"
  | "check_circle"
  | "check_circle_outline"
  | "checklist"
  | "checklist_rtl"
  | "checkroom"
  | "chevron_left"
  | "chevron_right"
  | "child_care"
  | "child_friendly"
  | "chrome_reader_mode"
  | "church"
  | "circle"
  | "circle_notifications"
  | "class"
  | "clean_hands"
  | "cleaning_services"
  | "clear"
  | "clear_all"
  | "close"
  | "close_fullscreen"
  | "closed_caption"
  | "closed_caption_disabled"
  | "closed_caption_off"
  | "cloud"
  | "cloud_circle"
  | "cloud_done"
  | "cloud_download"
  | "cloud_off"
  | "cloud_queue"
  | "cloud_sync"
  | "cloud_upload"
  | "cloudy_snowing"
  | "co2"
  | "co_present"
  | "code"
  | "code_off"
  | "coffee"
  | "coffee_maker"
  | "collections"
  | "collections_bookmark"
  | "color_lens"
  | "colorize"
  | "comment"
  | "comment_bank"
  | "comments_disabled"
  | "commit"
  | "commute"
  | "compare"
  | "compare_arrows"
  | "compass_calibration"
  | "compost"
  | "compress"
  | "computer"
  | "confirmation_number"
  | "connect_without_contact"
  | "connected_tv"
  | "connecting_airports"
  | "construction"
  | "contact_emergency"
  | "contact_mail"
  | "contact_page"
  | "contact_phone"
  | "contact_support"
  | "contactless"
  | "contacts"
  | "content_copy"
  | "content_cut"
  | "content_paste"
  | "content_paste_go"
  | "content_paste_off"
  | "content_paste_search"
  | "contrast"
  | "control_camera"
  | "control_point"
  | "control_point_duplicate"
  | "conveyor_belt"
  | "cookie"
  | "copy_all"
  | "copyright"
  | "coronavirus"
  | "corporate_fare"
  | "cottage"
  | "countertops"
  | "create"
  | "create_new_folder"
  | "credit_card"
  | "credit_card_off"
  | "credit_score"
  | "crib"
  | "crisis_alert"
  | "crop"
  | "crop_16_9"
  | "crop_3_2"
  | "crop_5_4"
  | "crop_7_5"
  | "crop_din"
  | "crop_free"
  | "crop_landscape"
  | "crop_original"
  | "crop_portrait"
  | "crop_rotate"
  | "crop_square"
  | "cruelty_free"
  | "css"
  | "currency_bitcoin"
  | "currency_exchange"
  | "currency_franc"
  | "currency_lira"
  | "currency_pound"
  | "currency_ruble"
  | "currency_rupee"
  | "currency_yen"
  | "currency_yuan"
  | "curtains"
  | "curtains_closed"
  | "cyclone"
  | "dangerous"
  | "dark_mode"
  | "dashboard"
  | "dashboard_customize"
  | "data_array"
  | "data_exploration"
  | "data_object"
  | "data_saver_off"
  | "data_saver_on"
  | "data_thresholding"
  | "data_usage"
  | "dataset"
  | "dataset_linked"
  | "date_range"
  | "deblur"
  | "deck"
  | "dehaze"
  | "delete"
  | "delete_forever"
  | "delete_outline"
  | "delete_sweep"
  | "delivery_dining"
  | "density_large"
  | "density_medium"
  | "density_small"
  | "departure_board"
  | "description"
  | "deselect"
  | "design_services"
  | "desk"
  | "desktop_access_disabled"
  | "desktop_mac"
  | "desktop_windows"
  | "details"
  | "developer_board"
  | "developer_board_off"
  | "developer_mode"
  | "device_hub"
  | "device_thermostat"
  | "device_unknown"
  | "devices"
  | "devices_fold"
  | "devices_other"
  | "dew_point"
  | "dialer_sip"
  | "dialpad"
  | "diamond"
  | "difference"
  | "dining"
  | "dinner_dining"
  | "directions"
  | "directions_bike"
  | "directions_boat"
  | "directions_boat_filled"
  | "directions_bus"
  | "directions_bus_filled"
  | "directions_car"
  | "directions_car_filled"
  | "directions_off"
  | "directions_railway"
  | "directions_railway_filled"
  | "directions_run"
  | "directions_subway"
  | "directions_subway_filled"
  | "directions_transit"
  | "directions_transit_filled"
  | "directions_walk"
  | "dirty_lens"
  | "disabled_by_default"
  | "disabled_visible"
  | "disc_full"
  | "discount"
  | "display_settings"
  | "diversity_1"
  | "diversity_2"
  | "diversity_3"
  | "dns"
  | "do_disturb"
  | "do_disturb_alt"
  | "do_disturb_off"
  | "do_disturb_on"
  | "do_not_disturb"
  | "do_not_disturb_alt"
  | "do_not_disturb_off"
  | "do_not_disturb_on"
  | "do_not_disturb_on_total_silence"
  | "do_not_step"
  | "do_not_touch"
  | "dock"
  | "document_scanner"
  | "domain"
  | "domain_add"
  | "domain_disabled"
  | "domain_verification"
  | "done"
  | "done_all"
  | "done_outline"
  | "donut_large"
  | "donut_small"
  | "door_back"
  | "door_front"
  | "door_sliding"
  | "doorbell"
  | "double_arrow"
  | "downhill_skiing"
  | "download"
  | "download_done"
  | "download_for_offline"
  | "downloading"
  | "drafts"
  | "drag_handle"
  | "drag_indicator"
  | "draw"
  | "drive_eta"
  | "drive_file_move"
  | "drive_file_move_outline"
  | "drive_file_move_rtl"
  | "drive_file_rename_outline"
  | "drive_folder_upload"
  | "dry"
  | "dry_cleaning"
  | "duo"
  | "dvr"
  | "dynamic_feed"
  | "dynamic_form"
  | "e_mobiledata"
  | "earbuds"
  | "earbuds_battery"
  | "east"
  | "edgesensor_high"
  | "edgesensor_low"
  | "edit"
  | "edit_attributes"
  | "edit_calendar"
  | "edit_document"
  | "edit_location"
  | "edit_location_alt"
  | "edit_note"
  | "edit_notifications"
  | "edit_off"
  | "edit_road"
  | "edit_square"
  | "egg"
  | "egg_alt"
  | "eject"
  | "elderly"
  | "elderly_woman"
  | "electric_bike"
  | "electric_bolt"
  | "electric_car"
  | "electric_meter"
  | "electric_moped"
  | "electric_rickshaw"
  | "electric_scooter"
  | "electrical_services"
  | "elevator"
  | "email"
  | "emergency"
  | "emergency_recording"
  | "emergency_share"
  | "emoji_emotions"
  | "emoji_events"
  | "emoji_food_beverage"
  | "emoji_nature"
  | "emoji_objects"
  | "emoji_people"
  | "emoji_symbols"
  | "emoji_transportation"
  | "energy_savings_leaf"
  | "engineering"
  | "enhanced_encryption"
  | "equalizer"
  | "error"
  | "error_outline"
  | "escalator"
  | "escalator_warning"
  | "euro"
  | "euro_symbol"
  | "ev_station"
  | "event"
  | "event_available"
  | "event_busy"
  | "event_note"
  | "event_repeat"
  | "event_seat"
  | "exit_to_app"
  | "expand"
  | "expand_circle_down"
  | "expand_less"
  | "expand_more"
  | "explicit"
  | "explore"
  | "explore_off"
  | "exposure"
  | "exposure_neg_1"
  | "exposure_neg_2"
  | "exposure_plus_1"
  | "exposure_plus_2"
  | "exposure_zero"
  | "extension"
  | "extension_off"
  | "face"
  | "face_2"
  | "face_3"
  | "face_4"
  | "face_5"
  | "face_6"
  | "face_retouching_natural"
  | "face_retouching_off"
  | "face_unlock"
  | "fact_check"
  | "factory"
  | "family_restroom"
  | "fast_forward"
  | "fast_rewind"
  | "fastfood"
  | "favorite"
  | "favorite_border"
  | "fax"
  | "featured_play_list"
  | "featured_video"
  | "feed"
  | "feedback"
  | "female"
  | "fence"
  | "festival"
  | "fiber_dvr"
  | "fiber_manual_record"
  | "fiber_new"
  | "fiber_pin"
  | "fiber_smart_record"
  | "file_copy"
  | "file_download"
  | "file_download_done"
  | "file_download_off"
  | "file_open"
  | "file_present"
  | "file_upload"
  | "file_upload_off"
  | "filter"
  | "filter_1"
  | "filter_2"
  | "filter_3"
  | "filter_4"
  | "filter_5"
  | "filter_6"
  | "filter_7"
  | "filter_8"
  | "filter_9"
  | "filter_9_plus"
  | "filter_alt"
  | "filter_alt_off"
  | "filter_b_and_w"
  | "filter_center_focus"
  | "filter_drama"
  | "filter_frames"
  | "filter_hdr"
  | "filter_list"
  | "filter_list_alt"
  | "filter_list_off"
  | "filter_none"
  | "filter_tilt_shift"
  | "filter_vintage"
  | "find_in_page"
  | "find_replace"
  | "fingerprint"
  | "fire_extinguisher"
  | "fire_hydrant_alt"
  | "fire_truck"
  | "fireplace"
  | "first_page"
  | "fit_screen"
  | "fitbit"
  | "fitness_center"
  | "flag"
  | "flag_circle"
  | "flaky"
  | "flare"
  | "flash_auto"
  | "flash_off"
  | "flash_on"
  | "flashlight_off"
  | "flashlight_on"
  | "flatware"
  | "flight"
  | "flight_class"
  | "flight_land"
  | "flight_takeoff"
  | "flip"
  | "flip_camera_android"
  | "flip_camera_ios"
  | "flip_to_back"
  | "flip_to_front"
  | "flood"
  | "fluorescent"
  | "flutter_dash"
  | "fmd_bad"
  | "fmd_good"
  | "foggy"
  | "folder"
  | "folder_copy"
  | "folder_delete"
  | "folder_off"
  | "folder_open"
  | "folder_shared"
  | "folder_special"
  | "folder_zip"
  | "follow_the_signs"
  | "font_download"
  | "font_download_off"
  | "food_bank"
  | "forest"
  | "fork_left"
  | "fork_right"
  | "forklift"
  | "format_align_center"
  | "format_align_justify"
  | "format_align_left"
  | "format_align_right"
  | "format_bold"
  | "format_clear"
  | "format_color_fill"
  | "format_color_reset"
  | "format_color_text"
  | "format_indent_decrease"
  | "format_indent_increase"
  | "format_italic"
  | "format_line_spacing"
  | "format_list_bulleted"
  | "format_list_bulleted_add"
  | "format_list_numbered"
  | "format_list_numbered_rtl"
  | "format_overline"
  | "format_paint"
  | "format_quote"
  | "format_shapes"
  | "format_size"
  | "format_strikethrough"
  | "format_textdirection_l_to_r"
  | "format_textdirection_r_to_l"
  | "format_underlined"
  | "fort"
  | "forum"
  | "forward"
  | "forward_10"
  | "forward_30"
  | "forward_5"
  | "forward_to_inbox"
  | "foundation"
  | "free_breakfast"
  | "free_cancellation"
  | "front_hand"
  | "front_loader"
  | "fullscreen"
  | "fullscreen_exit"
  | "functions"
  | "g_mobiledata"
  | "g_translate"
  | "gamepad"
  | "games"
  | "garage"
  | "gas_meter"
  | "gavel"
  | "generating_tokens"
  | "gesture"
  | "get_app"
  | "gif"
  | "gif_box"
  | "girl"
  | "gite"
  | "golf_course"
  | "gpp_bad"
  | "gpp_good"
  | "gpp_maybe"
  | "gps_fixed"
  | "gps_not_fixed"
  | "gps_off"
  | "grade"
  | "gradient"
  | "grading"
  | "grain"
  | "graphic_eq"
  | "grass"
  | "grid_3x3"
  | "grid_4x4"
  | "grid_goldenratio"
  | "grid_off"
  | "grid_on"
  | "grid_view"
  | "group"
  | "group_add"
  | "group_off"
  | "group_remove"
  | "group_work"
  | "groups"
  | "groups_2"
  | "groups_3"
  | "h_mobiledata"
  | "h_plus_mobiledata"
  | "hail"
  | "handshake"
  | "handyman"
  | "hardware"
  | "hd"
  | "hdr_auto"
  | "hdr_auto_select"
  | "hdr_enhanced_select"
  | "hdr_off"
  | "hdr_off_select"
  | "hdr_on"
  | "hdr_on_select"
  | "hdr_plus"
  | "hdr_strong"
  | "hdr_weak"
  | "headphones"
  | "headphones_battery"
  | "headset"
  | "headset_mic"
  | "headset_off"
  | "healing"
  | "health_and_safety"
  | "hearing"
  | "hearing_disabled"
  | "heart_broken"
  | "heat_pump"
  | "height"
  | "help"
  | "help_center"
  | "help_outline"
  | "hevc"
  | "hexagon"
  | "hide_image"
  | "hide_source"
  | "high_quality"
  | "highlight"
  | "highlight_alt"
  | "highlight_off"
  | "hiking"
  | "history"
  | "history_edu"
  | "history_toggle_off"
  | "hive"
  | "hls"
  | "hls_off"
  | "holiday_village"
  | "home"
  | "home_filled"
  | "home_max"
  | "home_mini"
  | "home_repair_service"
  | "home_work"
  | "horizontal_distribute"
  | "horizontal_rule"
  | "horizontal_split"
  | "hot_tub"
  | "hotel"
  | "hotel_class"
  | "hourglass_bottom"
  | "hourglass_disabled"
  | "hourglass_empty"
  | "hourglass_full"
  | "hourglass_top"
  | "house"
  | "house_siding"
  | "houseboat"
  | "how_to_reg"
  | "how_to_vote"
  | "html"
  | "http"
  | "https"
  | "hub"
  | "hvac"
  | "ice_skating"
  | "icecream"
  | "image"
  | "image_aspect_ratio"
  | "image_not_supported"
  | "image_search"
  | "imagesearch_roller"
  | "import_contacts"
  | "import_export"
  | "important_devices"
  | "inbox"
  | "incomplete_circle"
  | "indeterminate_check_box"
  | "info"
  | "info_outline"
  | "input"
  | "insert_chart"
  | "insert_chart_outlined"
  | "insert_comment"
  | "insert_drive_file"
  | "insert_emoticon"
  | "insert_invitation"
  | "insert_link"
  | "insert_page_break"
  | "insert_photo"
  | "insights"
  | "install_desktop"
  | "install_mobile"
  | "integration_instructions"
  | "interests"
  | "interpreter_mode"
  | "inventory"
  | "inventory_2"
  | "invert_colors"
  | "invert_colors_off"
  | "ios_share"
  | "iron"
  | "iso"
  | "javascript"
  | "join_full"
  | "join_inner"
  | "join_left"
  | "join_right"
  | "kayaking"
  | "kebab_dining"
  | "key"
  | "key_off"
  | "keyboard"
  | "keyboard_alt"
  | "keyboard_arrow_down"
  | "keyboard_arrow_left"
  | "keyboard_arrow_right"
  | "keyboard_arrow_up"
  | "keyboard_backspace"
  | "keyboard_capslock"
  | "keyboard_command_key"
  | "keyboard_control_key"
  | "keyboard_double_arrow_down"
  | "keyboard_double_arrow_left"
  | "keyboard_double_arrow_right"
  | "keyboard_double_arrow_up"
  | "keyboard_hide"
  | "keyboard_option_key"
  | "keyboard_return"
  | "keyboard_tab"
  | "keyboard_voice"
  | "king_bed"
  | "kitchen"
  | "kitesurfing"
  | "label"
  | "label_important"
  | "label_important_outline"
  | "label_off"
  | "lan"
  | "landscape"
  | "landslide"
  | "language"
  | "laptop"
  | "laptop_chromebook"
  | "laptop_mac"
  | "laptop_windows"
  | "last_page"
  | "launch"
  | "layers"
  | "layers_clear"
  | "leaderboard"
  | "leak_add"
  | "leak_remove"
  | "legend_toggle"
  | "lens"
  | "lens_blur"
  | "library_add"
  | "library_add_check"
  | "library_books"
  | "library_music"
  | "light"
  | "light_mode"
  | "lightbulb"
  | "lightbulb_circle"
  | "lightbulb_outline"
  | "line_axis"
  | "line_style"
  | "line_weight"
  | "linear_scale"
  | "link"
  | "link_off"
  | "linked_camera"
  | "liquor"
  | "list"
  | "list_alt"
  | "live_help"
  | "live_tv"
  | "living"
  | "local_activity"
  | "local_airport"
  | "local_atm"
  | "local_bar"
  | "local_cafe"
  | "local_car_wash"
  | "local_convenience_store"
  | "local_dining"
  | "local_drink"
  | "local_fire_department"
  | "local_florist"
  | "local_gas_station"
  | "local_grocery_store"
  | "local_hospital"
  | "local_hotel"
  | "local_laundry_service"
  | "local_library"
  | "local_mall"
  | "local_movies"
  | "local_offer"
  | "local_parking"
  | "local_pharmacy"
  | "local_phone"
  | "local_pizza"
  | "local_play"
  | "local_police"
  | "local_post_office"
  | "local_printshop"
  | "local_see"
  | "local_shipping"
  | "local_taxi"
  | "location_city"
  | "location_disabled"
  | "location_off"
  | "location_on"
  | "location_pin"
  | "location_searching"
  | "lock"
  | "lock_clock"
  | "lock_open"
  | "lock_outline"
  | "lock_person"
  | "lock_reset"
  | "login"
  | "logo_dev"
  | "logout"
  | "looks"
  | "looks_3"
  | "looks_4"
  | "looks_5"
  | "looks_6"
  | "looks_one"
  | "looks_two"
  | "loop"
  | "loupe"
  | "low_priority"
  | "loyalty"
  | "lte_mobiledata"
  | "lte_plus_mobiledata"
  | "luggage"
  | "lunch_dining"
  | "lyrics"
  | "macro_off"
  | "mail"
  | "mail_lock"
  | "mail_outline"
  | "male"
  | "man"
  | "man_2"
  | "man_3"
  | "man_4"
  | "manage_accounts"
  | "manage_history"
  | "manage_search"
  | "map"
  | "maps_home_work"
  | "maps_ugc"
  | "margin"
  | "mark_as_unread"
  | "mark_chat_read"
  | "mark_chat_unread"
  | "mark_email_read"
  | "mark_email_unread"
  | "mark_unread_chat_alt"
  | "markunread"
  | "markunread_mailbox"
  | "masks"
  | "maximize"
  | "media_bluetooth_off"
  | "media_bluetooth_on"
  | "mediation"
  | "medical_information"
  | "medical_services"
  | "medication"
  | "medication_liquid"
  | "meeting_room"
  | "memory"
  | "menu"
  | "menu_book"
  | "menu_open"
  | "merge"
  | "merge_type"
  | "message"
  | "mic"
  | "mic_external_off"
  | "mic_external_on"
  | "mic_none"
  | "mic_off"
  | "microwave"
  | "military_tech"
  | "minimize"
  | "minor_crash"
  | "miscellaneous_services"
  | "missed_video_call"
  | "mms"
  | "mobile_friendly"
  | "mobile_off"
  | "mobile_screen_share"
  | "mobiledata_off"
  | "mode"
  | "mode_comment"
  | "mode_edit"
  | "mode_edit_outline"
  | "mode_fan_off"
  | "mode_night"
  | "mode_of_travel"
  | "mode_standby"
  | "model_training"
  | "monetization_on"
  | "money"
  | "money_off"
  | "money_off_csred"
  | "monitor"
  | "monitor_heart"
  | "monitor_weight"
  | "monochrome_photos"
  | "mood"
  | "mood_bad"
  | "moped"
  | "more"
  | "more_horiz"
  | "more_time"
  | "more_vert"
  | "mosque"
  | "motion_photos_auto"
  | "motion_photos_off"
  | "motion_photos_on"
  | "motion_photos_pause"
  | "motion_photos_paused"
  | "mouse"
  | "move_down"
  | "move_to_inbox"
  | "move_up"
  | "movie"
  | "movie_creation"
  | "movie_edit"
  | "movie_filter"
  | "moving"
  | "mp"
  | "multiline_chart"
  | "multiple_stop"
  | "museum"
  | "music_note"
  | "music_off"
  | "music_video"
  | "my_location"
  | "nat"
  | "nature"
  | "nature_people"
  | "navigate_before"
  | "navigate_next"
  | "navigation"
  | "near_me"
  | "near_me_disabled"
  | "nearby_error"
  | "nearby_off"
  | "nest_cam_wired_stand"
  | "network_cell"
  | "network_check"
  | "network_locked"
  | "network_ping"
  | "network_wifi"
  | "network_wifi_1_bar"
  | "network_wifi_2_bar"
  | "network_wifi_3_bar"
  | "new_label"
  | "new_releases"
  | "newspaper"
  | "next_plan"
  | "next_week"
  | "nfc"
  | "night_shelter"
  | "nightlife"
  | "nightlight"
  | "nightlight_round"
  | "nights_stay"
  | "no_accounts"
  | "no_adult_content"
  | "no_backpack"
  | "no_cell"
  | "no_crash"
  | "no_drinks"
  | "no_encryption"
  | "no_encryption_gmailerrorred"
  | "no_flash"
  | "no_food"
  | "no_luggage"
  | "no_meals"
  | "no_meals_ouline"
  | "no_meeting_room"
  | "no_photography"
  | "no_sim"
  | "no_stroller"
  | "no_transfer"
  | "noise_aware"
  | "noise_control_off"
  | "nordic_walking"
  | "north"
  | "north_east"
  | "north_west"
  | "not_accessible"
  | "not_interested"
  | "not_listed_location"
  | "not_started"
  | "note"
  | "note_add"
  | "note_alt"
  | "notes"
  | "notification_add"
  | "notification_important"
  | "notifications"
  | "notifications_active"
  | "notifications_none"
  | "notifications_off"
  | "notifications_paused"
  | "numbers"
  | "offline_bolt"
  | "offline_pin"
  | "offline_share"
  | "oil_barrel"
  | "on_device_training"
  | "ondemand_video"
  | "online_prediction"
  | "opacity"
  | "open_in_browser"
  | "open_in_full"
  | "open_in_new"
  | "open_in_new_off"
  | "open_with"
  | "other_houses"
  | "outbound"
  | "outbox"
  | "outdoor_grill"
  | "outgoing_mail"
  | "outlet"
  | "outlined_flag"
  | "output"
  | "padding"
  | "pages"
  | "pageview"
  | "paid"
  | "palette"
  | "pallet"
  | "pan_tool"
  | "pan_tool_alt"
  | "panorama"
  | "panorama_fish_eye"
  | "panorama_horizontal"
  | "panorama_horizontal_select"
  | "panorama_photosphere"
  | "panorama_photosphere_select"
  | "panorama_vertical"
  | "panorama_vertical_select"
  | "panorama_wide_angle"
  | "panorama_wide_angle_select"
  | "paragliding"
  | "park"
  | "party_mode"
  | "password"
  | "pattern"
  | "pause"
  | "pause_circle"
  | "pause_circle_filled"
  | "pause_circle_outline"
  | "pause_presentation"
  | "payment"
  | "payments"
  | "pedal_bike"
  | "pending"
  | "pending_actions"
  | "pentagon"
  | "people"
  | "people_alt"
  | "people_outline"
  | "percent"
  | "perm_camera_mic"
  | "perm_contact_calendar"
  | "perm_data_setting"
  | "perm_device_information"
  | "perm_identity"
  | "perm_media"
  | "perm_phone_msg"
  | "perm_scan_wifi"
  | "person"
  | "person_2"
  | "person_3"
  | "person_4"
  | "person_add"
  | "person_add_alt"
  | "person_add_alt_1"
  | "person_add_disabled"
  | "person_off"
  | "person_outline"
  | "person_pin"
  | "person_pin_circle"
  | "person_remove"
  | "person_remove_alt_1"
  | "person_search"
  | "personal_injury"
  | "personal_video"
  | "pest_control"
  | "pest_control_rodent"
  | "pets"
  | "phishing"
  | "phone"
  | "phone_android"
  | "phone_bluetooth_speaker"
  | "phone_callback"
  | "phone_disabled"
  | "phone_enabled"
  | "phone_forwarded"
  | "phone_iphone"
  | "phone_locked"
  | "phone_missed"
  | "phone_paused"
  | "phonelink"
  | "phonelink_erase"
  | "phonelink_lock"
  | "phonelink_off"
  | "phonelink_ring"
  | "phonelink_setup"
  | "photo"
  | "photo_album"
  | "photo_camera"
  | "photo_camera_back"
  | "photo_camera_front"
  | "photo_filter"
  | "photo_library"
  | "photo_size_select_actual"
  | "photo_size_select_large"
  | "photo_size_select_small"
  | "php"
  | "piano"
  | "piano_off"
  | "picture_as_pdf"
  | "picture_in_picture"
  | "picture_in_picture_alt"
  | "pie_chart"
  | "pie_chart_outline"
  | "pie_chart_outlined"
  | "pin"
  | "pin_drop"
  | "pin_end"
  | "pin_invoke"
  | "pinch"
  | "pivot_table_chart"
  | "pix"
  | "place"
  | "plagiarism"
  | "play_arrow"
  | "play_circle"
  | "play_circle_filled"
  | "play_circle_outline"
  | "play_disabled"
  | "play_for_work"
  | "play_lesson"
  | "playlist_add"
  | "playlist_add_check"
  | "playlist_add_check_circle"
  | "playlist_add_circle"
  | "playlist_play"
  | "playlist_remove"
  | "plumbing"
  | "plus_one"
  | "podcasts"
  | "point_of_sale"
  | "policy"
  | "poll"
  | "polyline"
  | "polymer"
  | "pool"
  | "portable_wifi_off"
  | "portrait"
  | "post_add"
  | "power"
  | "power_input"
  | "power_off"
  | "power_settings_new"
  | "precision_manufacturing"
  | "pregnant_woman"
  | "present_to_all"
  | "preview"
  | "price_change"
  | "price_check"
  | "print"
  | "print_disabled"
  | "priority_high"
  | "privacy_tip"
  | "private_connectivity"
  | "production_quantity_limits"
  | "propane"
  | "propane_tank"
  | "psychology"
  | "psychology_alt"
  | "public"
  | "public_off"
  | "publish"
  | "published_with_changes"
  | "punch_clock"
  | "push_pin"
  | "qr_code"
  | "qr_code_2"
  | "qr_code_scanner"
  | "query_builder"
  | "query_stats"
  | "question_answer"
  | "question_mark"
  | "queue"
  | "queue_music"
  | "queue_play_next"
  | "quickreply"
  | "quiz"
  | "r_mobiledata"
  | "radar"
  | "radio"
  | "radio_button_checked"
  | "radio_button_unchecked"
  | "railway_alert"
  | "ramen_dining"
  | "ramp_left"
  | "ramp_right"
  | "rate_review"
  | "raw_off"
  | "raw_on"
  | "read_more"
  | "real_estate_agent"
  | "rebase_edit"
  | "receipt"
  | "receipt_long"
  | "recent_actors"
  | "recommend"
  | "record_voice_over"
  | "rectangle"
  | "recycling"
  | "redeem"
  | "redo"
  | "reduce_capacity"
  | "refresh"
  | "remember_me"
  | "remove"
  | "remove_circle"
  | "remove_circle_outline"
  | "remove_done"
  | "remove_from_queue"
  | "remove_moderator"
  | "remove_red_eye"
  | "remove_road"
  | "remove_shopping_cart"
  | "reorder"
  | "repartition"
  | "repeat"
  | "repeat_on"
  | "repeat_one"
  | "repeat_one_on"
  | "replay"
  | "replay_10"
  | "replay_30"
  | "replay_5"
  | "replay_circle_filled"
  | "reply"
  | "reply_all"
  | "report"
  | "report_gmailerrorred"
  | "report_off"
  | "report_problem"
  | "request_page"
  | "request_quote"
  | "reset_tv"
  | "restart_alt"
  | "restaurant"
  | "restaurant_menu"
  | "restore"
  | "restore_from_trash"
  | "restore_page"
  | "reviews"
  | "rice_bowl"
  | "ring_volume"
  | "rocket"
  | "rocket_launch"
  | "roller_shades"
  | "roller_shades_closed"
  | "roller_skating"
  | "roofing"
  | "room"
  | "room_preferences"
  | "room_service"
  | "rotate_90_degrees_ccw"
  | "rotate_90_degrees_cw"
  | "rotate_left"
  | "rotate_right"
  | "roundabout_left"
  | "roundabout_right"
  | "rounded_corner"
  | "route"
  | "router"
  | "rowing"
  | "rss_feed"
  | "rsvp"
  | "rtt"
  | "rule"
  | "rule_folder"
  | "run_circle"
  | "running_with_errors"
  | "rv_hookup"
  | "safety_check"
  | "safety_divider"
  | "sailing"
  | "sanitizer"
  | "satellite"
  | "satellite_alt"
  | "save"
  | "save_alt"
  | "save_as"
  | "saved_search"
  | "savings"
  | "scale"
  | "scanner"
  | "scatter_plot"
  | "schedule"
  | "schedule_send"
  | "schema"
  | "school"
  | "science"
  | "score"
  | "scoreboard"
  | "screen_lock_landscape"
  | "screen_lock_portrait"
  | "screen_lock_rotation"
  | "screen_rotation"
  | "screen_rotation_alt"
  | "screen_search_desktop"
  | "screen_share"
  | "screenshot"
  | "screenshot_monitor"
  | "scuba_diving"
  | "sd"
  | "sd_card"
  | "sd_card_alert"
  | "sd_storage"
  | "search"
  | "search_off"
  | "security"
  | "security_update"
  | "security_update_good"
  | "security_update_warning"
  | "segment"
  | "select_all"
  | "self_improvement"
  | "sell"
  | "send"
  | "send_and_archive"
  | "send_time_extension"
  | "send_to_mobile"
  | "sensor_door"
  | "sensor_occupied"
  | "sensor_window"
  | "sensors"
  | "sensors_off"
  | "sentiment_dissatisfied"
  | "sentiment_neutral"
  | "sentiment_satisfied"
  | "sentiment_satisfied_alt"
  | "sentiment_very_dissatisfied"
  | "sentiment_very_satisfied"
  | "set_meal"
  | "settings"
  | "settings_accessibility"
  | "settings_applications"
  | "settings_backup_restore"
  | "settings_bluetooth"
  | "settings_brightness"
  | "settings_cell"
  | "settings_ethernet"
  | "settings_input_antenna"
  | "settings_input_component"
  | "settings_input_composite"
  | "settings_input_hdmi"
  | "settings_input_svideo"
  | "settings_overscan"
  | "settings_phone"
  | "settings_power"
  | "settings_remote"
  | "settings_suggest"
  | "settings_system_daydream"
  | "settings_voice"
  | "severe_cold"
  | "shape_line"
  | "share"
  | "share_location"
  | "shelves"
  | "shield"
  | "shield_moon"
  | "shop"
  | "shop_2"
  | "shop_two"
  | "shopping_bag"
  | "shopping_basket"
  | "shopping_cart"
  | "shopping_cart_checkout"
  | "short_text"
  | "shortcut"
  | "show_chart"
  | "shower"
  | "shuffle"
  | "shuffle_on"
  | "shutter_speed"
  | "sick"
  | "sign_language"
  | "signal_cellular_0_bar"
  | "signal_cellular_1_bar"
  | "signal_cellular_2_bar"
  | "signal_cellular_3_bar"
  | "signal_cellular_4_bar"
  | "signal_cellular_alt"
  | "signal_cellular_alt_1_bar"
  | "signal_cellular_alt_2_bar"
  | "signal_cellular_connected_no_internet_0_bar"
  | "signal_cellular_connected_no_internet_1_bar"
  | "signal_cellular_connected_no_internet_2_bar"
  | "signal_cellular_connected_no_internet_3_bar"
  | "signal_cellular_connected_no_internet_4_bar"
  | "signal_cellular_no_sim"
  | "signal_cellular_nodata"
  | "signal_cellular_null"
  | "signal_cellular_off"
  | "signal_wifi_0_bar"
  | "signal_wifi_1_bar"
  | "signal_wifi_1_bar_lock"
  | "signal_wifi_2_bar"
  | "signal_wifi_2_bar_lock"
  | "signal_wifi_3_bar"
  | "signal_wifi_3_bar_lock"
  | "signal_wifi_4_bar"
  | "signal_wifi_4_bar_lock"
  | "signal_wifi_bad"
  | "signal_wifi_connected_no_internet_0"
  | "signal_wifi_connected_no_internet_1"
  | "signal_wifi_connected_no_internet_2"
  | "signal_wifi_connected_no_internet_3"
  | "signal_wifi_connected_no_internet_4"
  | "signal_wifi_off"
  | "signal_wifi_statusbar_1_bar"
  | "signal_wifi_statusbar_2_bar"
  | "signal_wifi_statusbar_3_bar"
  | "signal_wifi_statusbar_4_bar"
  | "signal_wifi_statusbar_connected_no_internet"
  | "signal_wifi_statusbar_connected_no_internet_1"
  | "signal_wifi_statusbar_connected_no_internet_2"
  | "signal_wifi_statusbar_connected_no_internet_3"
  | "signal_wifi_statusbar_connected_no_internet_4"
  | "signal_wifi_statusbar_not_connected"
  | "signal_wifi_statusbar_null"
  | "signpost"
  | "sim_card"
  | "sim_card_alert"
  | "sim_card_download"
  | "single_bed"
  | "sip"
  | "skateboarding"
  | "skip_next"
  | "skip_previous"
  | "sledding"
  | "slideshow"
  | "slow_motion_video"
  | "smart_button"
  | "smart_display"
  | "smart_screen"
  | "smart_toy"
  | "smartphone"
  | "smoke_free"
  | "smoking_rooms"
  | "sms"
  | "sms_failed"
  | "snippet_folder"
  | "snooze"
  | "snowboarding"
  | "snowing"
  | "snowmobile"
  | "snowshoeing"
  | "soap"
  | "social_distance"
  | "solar_power"
  | "sort"
  | "sort_by_alpha"
  | "sos"
  | "soup_kitchen"
  | "source"
  | "south"
  | "south_america"
  | "south_east"
  | "south_west"
  | "spa"
  | "space_bar"
  | "space_dashboard"
  | "spatial_audio"
  | "spatial_audio_off"
  | "spatial_tracking"
  | "speaker"
  | "speaker_group"
  | "speaker_notes"
  | "speaker_notes_off"
  | "speaker_phone"
  | "speed"
  | "spellcheck"
  | "splitscreen"
  | "spoke"
  | "sports"
  | "sports_bar"
  | "sports_baseball"
  | "sports_basketball"
  | "sports_cricket"
  | "sports_esports"
  | "sports_football"
  | "sports_golf"
  | "sports_gymnastics"
  | "sports_handball"
  | "sports_hockey"
  | "sports_kabaddi"
  | "sports_martial_arts"
  | "sports_mma"
  | "sports_motorsports"
  | "sports_rugby"
  | "sports_score"
  | "sports_soccer"
  | "sports_tennis"
  | "sports_volleyball"
  | "square"
  | "square_foot"
  | "ssid_chart"
  | "stacked_bar_chart"
  | "stacked_line_chart"
  | "stadium"
  | "stairs"
  | "star"
  | "star_border"
  | "star_border_purple500"
  | "star_half"
  | "star_outline"
  | "star_purple500"
  | "star_rate"
  | "stars"
  | "start"
  | "stay_current_landscape"
  | "stay_current_portrait"
  | "stay_primary_landscape"
  | "stay_primary_portrait"
  | "sticky_note_2"
  | "stop"
  | "stop_circle"
  | "stop_screen_share"
  | "storage"
  | "store"
  | "store_mall_directory"
  | "storefront"
  | "storm"
  | "straight"
  | "straighten"
  | "stream"
  | "streetview"
  | "strikethrough_s"
  | "stroller"
  | "style"
  | "subdirectory_arrow_left"
  | "subdirectory_arrow_right"
  | "subject"
  | "subscript"
  | "subscriptions"
  | "subtitles"
  | "subtitles_off"
  | "subway"
  | "summarize"
  | "sunny"
  | "sunny_snowing"
  | "superscript"
  | "supervised_user_circle"
  | "supervisor_account"
  | "support"
  | "support_agent"
  | "surfing"
  | "surround_sound"
  | "swap_calls"
  | "swap_horiz"
  | "swap_horizontal_circle"
  | "swap_vert"
  | "swap_vertical_circle"
  | "swipe"
  | "swipe_down"
  | "swipe_down_alt"
  | "swipe_left"
  | "swipe_left_alt"
  | "swipe_right"
  | "swipe_right_alt"
  | "swipe_up"
  | "swipe_up_alt"
  | "swipe_vertical"
  | "switch_access_shortcut"
  | "switch_access_shortcut_add"
  | "switch_account"
  | "switch_camera"
  | "switch_left"
  | "switch_right"
  | "switch_video"
  | "synagogue"
  | "sync"
  | "sync_alt"
  | "sync_disabled"
  | "sync_lock"
  | "sync_problem"
  | "system_security_update"
  | "system_security_update_good"
  | "system_security_update_warning"
  | "system_update"
  | "system_update_alt"
  | "tab"
  | "tab_unselected"
  | "table_bar"
  | "table_chart"
  | "table_restaurant"
  | "table_rows"
  | "table_view"
  | "tablet"
  | "tablet_android"
  | "tablet_mac"
  | "tag"
  | "tag_faces"
  | "takeout_dining"
  | "tap_and_play"
  | "tapas"
  | "task"
  | "task_alt"
  | "taxi_alert"
  | "temple_buddhist"
  | "temple_hindu"
  | "terminal"
  | "terrain"
  | "text_decrease"
  | "text_fields"
  | "text_format"
  | "text_increase"
  | "text_rotate_up"
  | "text_rotate_vertical"
  | "text_rotation_angledown"
  | "text_rotation_angleup"
  | "text_rotation_down"
  | "text_rotation_none"
  | "text_snippet"
  | "textsms"
  | "texture"
  | "theater_comedy"
  | "theaters"
  | "thermostat"
  | "thermostat_auto"
  | "thumb_down"
  | "thumb_down_alt"
  | "thumb_down_off_alt"
  | "thumb_up"
  | "thumb_up_alt"
  | "thumb_up_off_alt"
  | "thumbs_up_down"
  | "thunderstorm"
  | "time_to_leave"
  | "timelapse"
  | "timeline"
  | "timer"
  | "timer_10"
  | "timer_10_select"
  | "timer_3"
  | "timer_3_select"
  | "timer_off"
  | "tips_and_updates"
  | "tire_repair"
  | "title"
  | "toc"
  | "today"
  | "toggle_off"
  | "toggle_on"
  | "token"
  | "toll"
  | "tonality"
  | "topic"
  | "tornado"
  | "touch_app"
  | "tour"
  | "toys"
  | "track_changes"
  | "traffic"
  | "train"
  | "tram"
  | "transcribe"
  | "transfer_within_a_station"
  | "transform"
  | "transgender"
  | "transit_enterexit"
  | "translate"
  | "travel_explore"
  | "trending_down"
  | "trending_flat"
  | "trending_up"
  | "trip_origin"
  | "trolley"
  | "troubleshoot"
  | "try"
  | "tsunami"
  | "tty"
  | "tune"
  | "tungsten"
  | "turn_left"
  | "turn_right"
  | "turn_sharp_left"
  | "turn_sharp_right"
  | "turn_slight_left"
  | "turn_slight_right"
  | "turned_in"
  | "turned_in_not"
  | "tv"
  | "tv_off"
  | "two_wheeler"
  | "type_specimen"
  | "u_turn_left"
  | "u_turn_right"
  | "umbrella"
  | "unarchive"
  | "undo"
  | "unfold_less"
  | "unfold_less_double"
  | "unfold_more"
  | "unfold_more_double"
  | "unpublished"
  | "unsubscribe"
  | "upcoming"
  | "update"
  | "update_disabled"
  | "upgrade"
  | "upload"
  | "upload_file"
  | "usb"
  | "usb_off"
  | "vaccines"
  | "vape_free"
  | "vaping_rooms"
  | "verified"
  | "verified_user"
  | "vertical_align_bottom"
  | "vertical_align_center"
  | "vertical_align_top"
  | "vertical_distribute"
  | "vertical_shades"
  | "vertical_shades_closed"
  | "vertical_split"
  | "vibration"
  | "video_call"
  | "video_camera_back"
  | "video_camera_front"
  | "video_chat"
  | "video_file"
  | "video_label"
  | "video_library"
  | "video_settings"
  | "video_stable"
  | "videocam"
  | "videocam_off"
  | "videogame_asset"
  | "videogame_asset_off"
  | "view_agenda"
  | "view_array"
  | "view_carousel"
  | "view_column"
  | "view_comfy"
  | "view_comfy_alt"
  | "view_compact"
  | "view_compact_alt"
  | "view_cozy"
  | "view_day"
  | "view_headline"
  | "view_in_ar"
  | "view_kanban"
  | "view_list"
  | "view_module"
  | "view_quilt"
  | "view_sidebar"
  | "view_stream"
  | "view_timeline"
  | "view_week"
  | "vignette"
  | "villa"
  | "visibility"
  | "visibility_off"
  | "voice_chat"
  | "voice_over_off"
  | "voicemail"
  | "volcano"
  | "volume_down"
  | "volume_down_alt"
  | "volume_mute"
  | "volume_off"
  | "volume_up"
  | "volunteer_activism"
  | "vpn_key"
  | "vpn_key_off"
  | "vpn_lock"
  | "vrpano"
  | "wallet"
  | "wallpaper"
  | "warehouse"
  | "warning"
  | "warning_amber"
  | "wash"
  | "watch"
  | "watch_later"
  | "watch_off"
  | "water"
  | "water_damage"
  | "water_drop"
  | "waterfall_chart"
  | "waves"
  | "waving_hand"
  | "wb_auto"
  | "wb_cloudy"
  | "wb_incandescent"
  | "wb_iridescent"
  | "wb_shade"
  | "wb_sunny"
  | "wb_twighlight"
  | "wb_twilight"
  | "wc"
  | "web"
  | "web_asset"
  | "web_asset_off"
  | "web_stories"
  | "webhook"
  | "weekend"
  | "west"
  | "whatshot"
  | "wheelchair_pickup"
  | "where_to_vote"
  | "widgets"
  | "width_full"
  | "width_normal"
  | "width_wide"
  | "wifi"
  | "wifi_1_bar"
  | "wifi_2_bar"
  | "wifi_calling"
  | "wifi_calling_1"
  | "wifi_calling_2"
  | "wifi_calling_3"
  | "wifi_channel"
  | "wifi_find"
  | "wifi_lock"
  | "wifi_off"
  | "wifi_password"
  | "wifi_protected_setup"
  | "wifi_tethering"
  | "wifi_tethering_error"
  | "wifi_tethering_off"
  | "wind_power"
  | "window"
  | "wine_bar"
  | "woman"
  | "woman_2"
  | "work"
  | "work_history"
  | "work_off"
  | "work_outline"
  | "workspace_premium"
  | "workspaces"
  | "workspaces_filled"
  | "workspaces_outline"
  | "wrap_text"
  | "wrong_location"
  | "wysiwyg"
  | "yard"
  | "youtube_searched_for"
  | "zoom_in"
  | "zoom_in_map"
  | "zoom_out"
  | "zoom_out_map";

/** @since 6.0.0 */
export type MaterialSymbolFamily = "outlined" | "rounded" | "sharp";

/** @since 6.0.0 */
export type MaterialSymbolName =
  | "10k"
  | "10mp"
  | "11mp"
  | "123"
  | "12mp"
  | "13mp"
  | "14mp"
  | "15mp"
  | "16mp"
  | "17mp"
  | "18_up_rating"
  | "18mp"
  | "19mp"
  | "1k"
  | "1k_plus"
  | "1x_mobiledata"
  | "1x_mobiledata_badge"
  | "20mp"
  | "21mp"
  | "22mp"
  | "23mp"
  | "24fps_select"
  | "24mp"
  | "2d"
  | "2k"
  | "2k_plus"
  | "2mp"
  | "30fps"
  | "30fps_select"
  | "360"
  | "3d_rotation"
  | "3g_mobiledata"
  | "3g_mobiledata_badge"
  | "3k"
  | "3k_plus"
  | "3mp"
  | "3p"
  | "4g_mobiledata"
  | "4g_mobiledata_badge"
  | "4g_plus_mobiledata"
  | "4k"
  | "4k_plus"
  | "4mp"
  | "50mp"
  | "5g"
  | "5g_mobiledata_badge"
  | "5k"
  | "5k_plus"
  | "5mp"
  | "60fps"
  | "60fps_select"
  | "6_ft_apart"
  | "6k"
  | "6k_plus"
  | "6mp"
  | "7k"
  | "7k_plus"
  | "7mp"
  | "8k"
  | "8k_plus"
  | "8mp"
  | "9k"
  | "9k_plus"
  | "9mp"
  | "abc"
  | "ac_unit"
  | "accessibility"
  | "accessibility_new"
  | "accessible"
  | "accessible_forward"
  | "accessible_menu"
  | "account_balance"
  | "account_balance_wallet"
  | "account_box"
  | "account_child"
  | "account_child_invert"
  | "account_circle"
  | "account_circle_off"
  | "account_tree"
  | "action_key"
  | "activity_zone"
  | "acute"
  | "ad"
  | "ad_group"
  | "ad_group_off"
  | "ad_off"
  | "ad_units"
  | "adaptive_audio_mic"
  | "adaptive_audio_mic_off"
  | "adb"
  | "add"
  | "add_2"
  | "add_a_photo"
  | "add_ad"
  | "add_alert"
  | "add_box"
  | "add_business"
  | "add_call"
  | "add_card"
  | "add_chart"
  | "add_circle"
  | "add_column_left"
  | "add_column_right"
  | "add_comment"
  | "add_diamond"
  | "add_home"
  | "add_home_work"
  | "add_link"
  | "add_location"
  | "add_location_alt"
  | "add_moderator"
  | "add_notes"
  | "add_photo_alternate"
  | "add_reaction"
  | "add_road"
  | "add_row_above"
  | "add_row_below"
  | "add_shopping_cart"
  | "add_task"
  | "add_to_drive"
  | "add_to_home_screen"
  | "add_to_queue"
  | "add_triangle"
  | "adf_scanner"
  | "adjust"
  | "admin_meds"
  | "admin_panel_settings"
  | "ads_click"
  | "agender"
  | "agriculture"
  | "air"
  | "air_freshener"
  | "air_purifier"
  | "air_purifier_gen"
  | "airline_seat_flat"
  | "airline_seat_flat_angled"
  | "airline_seat_individual_suite"
  | "airline_seat_legroom_extra"
  | "airline_seat_legroom_normal"
  | "airline_seat_legroom_reduced"
  | "airline_seat_recline_extra"
  | "airline_seat_recline_normal"
  | "airline_stops"
  | "airlines"
  | "airplane_ticket"
  | "airplanemode_inactive"
  | "airplay"
  | "airport_shuttle"
  | "airware"
  | "airwave"
  | "alarm"
  | "alarm_add"
  | "alarm_off"
  | "alarm_on"
  | "alarm_pause"
  | "alarm_smart_wake"
  | "album"
  | "align_center"
  | "align_end"
  | "align_flex_center"
  | "align_flex_end"
  | "align_flex_start"
  | "align_horizontal_center"
  | "align_horizontal_left"
  | "align_horizontal_right"
  | "align_items_stretch"
  | "align_justify_center"
  | "align_justify_flex_end"
  | "align_justify_flex_start"
  | "align_justify_space_around"
  | "align_justify_space_between"
  | "align_justify_space_even"
  | "align_justify_stretch"
  | "align_self_stretch"
  | "align_space_around"
  | "align_space_between"
  | "align_space_even"
  | "align_start"
  | "align_stretch"
  | "align_vertical_bottom"
  | "align_vertical_center"
  | "align_vertical_top"
  | "all_inbox"
  | "all_inclusive"
  | "all_match"
  | "all_out"
  | "allergies"
  | "allergy"
  | "alt_route"
  | "alternate_email"
  | "altitude"
  | "ambulance"
  | "amend"
  | "amp_stories"
  | "analytics"
  | "anchor"
  | "android"
  | "animated_images"
  | "animation"
  | "aod"
  | "aod_tablet"
  | "aod_watch"
  | "apartment"
  | "api"
  | "apk_document"
  | "apk_install"
  | "app_badging"
  | "app_blocking"
  | "app_promo"
  | "app_registration"
  | "app_shortcut"
  | "apparel"
  | "approval"
  | "approval_delegation"
  | "apps"
  | "apps_outage"
  | "aq"
  | "aq_indoor"
  | "ar_on_you"
  | "ar_stickers"
  | "architecture"
  | "archive"
  | "area_chart"
  | "arming_countdown"
  | "arrow_and_edge"
  | "arrow_back"
  | "arrow_back_2"
  | "arrow_back_ios"
  | "arrow_back_ios_new"
  | "arrow_circle_down"
  | "arrow_circle_left"
  | "arrow_circle_right"
  | "arrow_circle_up"
  | "arrow_cool_down"
  | "arrow_downward"
  | "arrow_downward_alt"
  | "arrow_drop_down"
  | "arrow_drop_down_circle"
  | "arrow_drop_up"
  | "arrow_forward"
  | "arrow_forward_ios"
  | "arrow_insert"
  | "arrow_left"
  | "arrow_left_alt"
  | "arrow_menu_close"
  | "arrow_menu_open"
  | "arrow_or_edge"
  | "arrow_outward"
  | "arrow_range"
  | "arrow_right"
  | "arrow_right_alt"
  | "arrow_selector_tool"
  | "arrow_split"
  | "arrow_top_left"
  | "arrow_top_right"
  | "arrow_upload_progress"
  | "arrow_upload_ready"
  | "arrow_upward"
  | "arrow_upward_alt"
  | "arrow_warm_up"
  | "arrows_input"
  | "arrows_more_down"
  | "arrows_more_up"
  | "arrows_output"
  | "arrows_outward"
  | "art_track"
  | "article"
  | "article_person"
  | "article_shortcut"
  | "artist"
  | "aspect_ratio"
  | "assignment"
  | "assignment_add"
  | "assignment_ind"
  | "assignment_late"
  | "assignment_return"
  | "assignment_returned"
  | "assignment_turned_in"
  | "assist_walker"
  | "assistant_device"
  | "assistant_direction"
  | "assistant_navigation"
  | "assistant_on_hub"
  | "assured_workload"
  | "asterisk"
  | "atm"
  | "atr"
  | "attach_email"
  | "attach_file"
  | "attach_file_add"
  | "attach_file_off"
  | "attach_money"
  | "attachment"
  | "attractions"
  | "attribution"
  | "audio_description"
  | "audio_file"
  | "audio_video_receiver"
  | "auto_awesome_mosaic"
  | "auto_awesome_motion"
  | "auto_delete"
  | "auto_read_pause"
  | "auto_read_play"
  | "auto_stories"
  | "auto_towing"
  | "auto_transmission"
  | "autofps_select"
  | "automation"
  | "autopause"
  | "autoplay"
  | "autorenew"
  | "autostop"
  | "av1"
  | "av_timer"
  | "avc"
  | "avg_pace"
  | "avg_time"
  | "award_star"
  | "azm"
  | "baby_changing_station"
  | "back_hand"
  | "back_to_tab"
  | "background_dot_large"
  | "background_dot_small"
  | "background_grid_small"
  | "background_replace"
  | "backlight_high"
  | "backlight_high_off"
  | "backlight_low"
  | "backpack"
  | "backspace"
  | "backup"
  | "backup_table"
  | "badge"
  | "badge_critical_battery"
  | "bakery_dining"
  | "balance"
  | "balcony"
  | "ballot"
  | "bar_chart"
  | "bar_chart_4_bars"
  | "bar_chart_off"
  | "barcode"
  | "barcode_reader"
  | "barcode_scanner"
  | "barefoot"
  | "batch_prediction"
  | "bath_outdoor"
  | "bath_private"
  | "bath_public_large"
  | "bathroom"
  | "bathtub"
  | "battery_0_bar"
  | "battery_1_bar"
  | "battery_2_bar"
  | "battery_3_bar"
  | "battery_4_bar"
  | "battery_5_bar"
  | "battery_6_bar"
  | "battery_alert"
  | "battery_change"
  | "battery_charging_20"
  | "battery_charging_30"
  | "battery_charging_50"
  | "battery_charging_60"
  | "battery_charging_80"
  | "battery_charging_90"
  | "battery_charging_full"
  | "battery_error"
  | "battery_full"
  | "battery_full_alt"
  | "battery_horiz_000"
  | "battery_horiz_050"
  | "battery_horiz_075"
  | "battery_low"
  | "battery_plus"
  | "battery_profile"
  | "battery_saver"
  | "battery_share"
  | "battery_status_good"
  | "battery_unknown"
  | "battery_very_low"
  | "beach_access"
  | "bed"
  | "bedroom_baby"
  | "bedroom_child"
  | "bedroom_parent"
  | "bedtime"
  | "bedtime_off"
  | "beenhere"
  | "bento"
  | "bia"
  | "bid_landscape"
  | "bid_landscape_disabled"
  | "bigtop_updates"
  | "bike_dock"
  | "bike_lane"
  | "bike_scooter"
  | "biotech"
  | "blanket"
  | "blender"
  | "blind"
  | "blinds"
  | "blinds_closed"
  | "block"
  | "blood_pressure"
  | "bloodtype"
  | "bluetooth"
  | "bluetooth_connected"
  | "bluetooth_disabled"
  | "bluetooth_drive"
  | "bluetooth_searching"
  | "blur_circular"
  | "blur_linear"
  | "blur_medium"
  | "blur_off"
  | "blur_on"
  | "blur_short"
  | "boat_bus"
  | "boat_railway"
  | "body_fat"
  | "body_system"
  | "bolt"
  | "bomb"
  | "book"
  | "book_2"
  | "book_3"
  | "book_4"
  | "book_4_spark"
  | "book_5"
  | "book_6"
  | "book_online"
  | "book_ribbon"
  | "bookmark"
  | "bookmark_add"
  | "bookmark_added"
  | "bookmark_bag"
  | "bookmark_check"
  | "bookmark_flag"
  | "bookmark_heart"
  | "bookmark_manager"
  | "bookmark_remove"
  | "bookmark_star"
  | "bookmarks"
  | "books_movies_and_music"
  | "border_all"
  | "border_bottom"
  | "border_clear"
  | "border_color"
  | "border_horizontal"
  | "border_inner"
  | "border_left"
  | "border_outer"
  | "border_right"
  | "border_style"
  | "border_top"
  | "border_vertical"
  | "borg"
  | "bottom_app_bar"
  | "bottom_drawer"
  | "bottom_navigation"
  | "bottom_panel_close"
  | "bottom_panel_open"
  | "bottom_right_click"
  | "bottom_sheets"
  | "box"
  | "box_add"
  | "box_edit"
  | "boy"
  | "brand_awareness"
  | "brand_family"
  | "branding_watermark"
  | "breakfast_dining"
  | "breaking_news"
  | "breaking_news_alt_1"
  | "breastfeeding"
  | "brick"
  | "brightness_1"
  | "brightness_2"
  | "brightness_3"
  | "brightness_4"
  | "brightness_5"
  | "brightness_6"
  | "brightness_7"
  | "brightness_alert"
  | "brightness_auto"
  | "brightness_empty"
  | "brightness_medium"
  | "bring_your_own_ip"
  | "broadcast_on_home"
  | "broadcast_on_personal"
  | "broken_image"
  | "browse"
  | "browse_activity"
  | "browse_gallery"
  | "browser_updated"
  | "brunch_dining"
  | "brush"
  | "bubble"
  | "bubble_chart"
  | "bubbles"
  | "bug_report"
  | "build"
  | "build_circle"
  | "bungalow"
  | "burst_mode"
  | "bus_alert"
  | "bus_railway"
  | "business_center"
  | "business_chip"
  | "business_messages"
  | "buttons_alt"
  | "cabin"
  | "cable"
  | "cable_car"
  | "cached"
  | "cadence"
  | "cake"
  | "cake_add"
  | "calculate"
  | "calendar_add_on"
  | "calendar_apps_script"
  | "calendar_clock"
  | "calendar_month"
  | "calendar_today"
  | "calendar_view_day"
  | "calendar_view_month"
  | "calendar_view_week"
  | "call"
  | "call_end"
  | "call_log"
  | "call_made"
  | "call_merge"
  | "call_missed"
  | "call_missed_outgoing"
  | "call_quality"
  | "call_received"
  | "call_split"
  | "call_to_action"
  | "camera"
  | "camera_front"
  | "camera_indoor"
  | "camera_outdoor"
  | "camera_rear"
  | "camera_roll"
  | "camera_video"
  | "cameraswitch"
  | "campaign"
  | "camping"
  | "cancel"
  | "cancel_presentation"
  | "cancel_schedule_send"
  | "candle"
  | "candlestick_chart"
  | "captive_portal"
  | "capture"
  | "car_crash"
  | "car_defrost_left"
  | "car_defrost_low_left"
  | "car_defrost_low_right"
  | "car_defrost_mid_low_left"
  | "car_defrost_mid_right"
  | "car_defrost_right"
  | "car_fan_low_left"
  | "car_fan_low_mid_left"
  | "car_fan_low_right"
  | "car_fan_mid_left"
  | "car_fan_mid_low_right"
  | "car_fan_mid_right"
  | "car_fan_recirculate"
  | "car_gear"
  | "car_lock"
  | "car_mirror_heat"
  | "car_rental"
  | "car_repair"
  | "car_tag"
  | "card_membership"
  | "card_travel"
  | "cardio_load"
  | "cardiology"
  | "cards"
  | "cards_star"
  | "carpenter"
  | "carry_on_bag"
  | "carry_on_bag_checked"
  | "carry_on_bag_inactive"
  | "carry_on_bag_question"
  | "cases"
  | "casino"
  | "cast"
  | "cast_connected"
  | "cast_for_education"
  | "cast_pause"
  | "cast_warning"
  | "castle"
  | "category"
  | "category_search"
  | "celebration"
  | "cell_merge"
  | "cell_tower"
  | "cell_wifi"
  | "center_focus_strong"
  | "center_focus_weak"
  | "chair"
  | "chair_alt"
  | "chalet"
  | "change_circle"
  | "change_history"
  | "charger"
  | "charging_station"
  | "chart_data"
  | "chat"
  | "chat_add_on"
  | "chat_apps_script"
  | "chat_bubble"
  | "chat_error"
  | "chat_info"
  | "chat_paste_go"
  | "chat_paste_go_2"
  | "check"
  | "check_box"
  | "check_box_outline_blank"
  | "check_circle"
  | "check_in_out"
  | "check_indeterminate_small"
  | "check_small"
  | "checkbook"
  | "checked_bag"
  | "checked_bag_question"
  | "checklist"
  | "checklist_rtl"
  | "checkroom"
  | "cheer"
  | "chef_hat"
  | "chess"
  | "chess_pawn"
  | "chevron_backward"
  | "chevron_forward"
  | "chevron_left"
  | "chevron_right"
  | "child_care"
  | "child_friendly"
  | "chip_extraction"
  | "chips"
  | "chrome_reader_mode"
  | "chromecast_2"
  | "chromecast_device"
  | "chronic"
  | "church"
  | "cinematic_blur"
  | "circle"
  | "circle_notifications"
  | "circles"
  | "circles_ext"
  | "clarify"
  | "clean_hands"
  | "cleaning"
  | "cleaning_bucket"
  | "cleaning_services"
  | "clear_all"
  | "clear_day"
  | "climate_mini_split"
  | "clinical_notes"
  | "clock_arrow_down"
  | "clock_arrow_up"
  | "clock_loader_10"
  | "clock_loader_20"
  | "clock_loader_40"
  | "clock_loader_60"
  | "clock_loader_80"
  | "clock_loader_90"
  | "close"
  | "close_fullscreen"
  | "close_small"
  | "closed_caption"
  | "closed_caption_add"
  | "closed_caption_disabled"
  | "cloud"
  | "cloud_alert"
  | "cloud_circle"
  | "cloud_done"
  | "cloud_download"
  | "cloud_lock"
  | "cloud_off"
  | "cloud_sync"
  | "cloud_upload"
  | "co2"
  | "co_present"
  | "code"
  | "code_blocks"
  | "code_off"
  | "coffee"
  | "coffee_maker"
  | "cognition"
  | "cognition_2"
  | "collapse_all"
  | "collapse_content"
  | "collections_bookmark"
  | "colorize"
  | "colors"
  | "combine_columns"
  | "comedy_mask"
  | "comic_bubble"
  | "comment"
  | "comment_bank"
  | "comments_disabled"
  | "commit"
  | "communication"
  | "communities"
  | "commute"
  | "compare"
  | "compare_arrows"
  | "compass_calibration"
  | "component_exchange"
  | "compost"
  | "compress"
  | "computer"
  | "concierge"
  | "conditions"
  | "confirmation_number"
  | "congenital"
  | "connect_without_contact"
  | "connected_tv"
  | "connecting_airports"
  | "construction"
  | "contact_emergency"
  | "contact_mail"
  | "contact_page"
  | "contact_phone"
  | "contact_support"
  | "contactless"
  | "contactless_off"
  | "contacts"
  | "contacts_product"
  | "content_copy"
  | "content_cut"
  | "content_paste"
  | "content_paste_go"
  | "content_paste_off"
  | "content_paste_search"
  | "contextual_token"
  | "contextual_token_add"
  | "contract"
  | "contract_delete"
  | "contract_edit"
  | "contrast"
  | "contrast_circle"
  | "contrast_rtl_off"
  | "contrast_square"
  | "control_camera"
  | "control_point_duplicate"
  | "controller_gen"
  | "conversion_path"
  | "conversion_path_off"
  | "convert_to_text"
  | "conveyor_belt"
  | "cookie"
  | "cookie_off"
  | "cooking"
  | "cool_to_dry"
  | "copy_all"
  | "copyright"
  | "coronavirus"
  | "corporate_fare"
  | "cottage"
  | "counter_0"
  | "counter_1"
  | "counter_2"
  | "counter_3"
  | "counter_4"
  | "counter_5"
  | "counter_6"
  | "counter_7"
  | "counter_8"
  | "counter_9"
  | "countertops"
  | "create_new_folder"
  | "credit_card"
  | "credit_card_clock"
  | "credit_card_gear"
  | "credit_card_heart"
  | "credit_card_off"
  | "credit_score"
  | "crib"
  | "crisis_alert"
  | "crop"
  | "crop_16_9"
  | "crop_3_2"
  | "crop_5_4"
  | "crop_7_5"
  | "crop_9_16"
  | "crop_free"
  | "crop_landscape"
  | "crop_portrait"
  | "crop_rotate"
  | "crop_square"
  | "crossword"
  | "crowdsource"
  | "crown"
  | "cruelty_free"
  | "css"
  | "csv"
  | "currency_bitcoin"
  | "currency_exchange"
  | "currency_franc"
  | "currency_lira"
  | "currency_pound"
  | "currency_ruble"
  | "currency_rupee"
  | "currency_rupee_circle"
  | "currency_yen"
  | "currency_yuan"
  | "curtains"
  | "curtains_closed"
  | "custom_typography"
  | "cycle"
  | "cyclone"
  | "dangerous"
  | "dark_mode"
  | "dashboard"
  | "dashboard_2"
  | "dashboard_customize"
  | "data_alert"
  | "data_array"
  | "data_check"
  | "data_exploration"
  | "data_info_alert"
  | "data_loss_prevention"
  | "data_object"
  | "data_saver_on"
  | "data_table"
  | "data_thresholding"
  | "data_usage"
  | "database"
  | "database_off"
  | "database_search"
  | "database_upload"
  | "dataset"
  | "dataset_linked"
  | "date_range"
  | "deblur"
  | "deceased"
  | "decimal_decrease"
  | "decimal_increase"
  | "deck"
  | "dehaze"
  | "delete"
  | "delete_forever"
  | "delete_history"
  | "delete_sweep"
  | "delivery_truck_bolt"
  | "delivery_truck_speed"
  | "demography"
  | "density_large"
  | "density_medium"
  | "density_small"
  | "dentistry"
  | "departure_board"
  | "deployed_code"
  | "deployed_code_account"
  | "deployed_code_alert"
  | "deployed_code_history"
  | "deployed_code_update"
  | "dermatology"
  | "description"
  | "deselect"
  | "design_services"
  | "desk"
  | "deskphone"
  | "desktop_access_disabled"
  | "desktop_cloud"
  | "desktop_cloud_stack"
  | "desktop_landscape"
  | "desktop_landscape_add"
  | "desktop_mac"
  | "desktop_portrait"
  | "desktop_windows"
  | "destruction"
  | "details"
  | "detection_and_zone"
  | "detector"
  | "detector_alarm"
  | "detector_battery"
  | "detector_co"
  | "detector_offline"
  | "detector_smoke"
  | "detector_status"
  | "developer_board"
  | "developer_board_off"
  | "developer_guide"
  | "developer_mode"
  | "developer_mode_tv"
  | "device_hub"
  | "device_thermostat"
  | "device_unknown"
  | "devices"
  | "devices_fold"
  | "devices_fold_2"
  | "devices_off"
  | "devices_other"
  | "devices_wearables"
  | "dew_point"
  | "diagnosis"
  | "diagonal_line"
  | "dialer_sip"
  | "dialogs"
  | "dialpad"
  | "diamond"
  | "dictionary"
  | "difference"
  | "digital_out_of_home"
  | "digital_wellbeing"
  | "dining"
  | "dinner_dining"
  | "directions"
  | "directions_alt"
  | "directions_alt_off"
  | "directions_bike"
  | "directions_boat"
  | "directions_bus"
  | "directions_car"
  | "directions_off"
  | "directions_railway"
  | "directions_railway_2"
  | "directions_run"
  | "directions_subway"
  | "directions_walk"
  | "directory_sync"
  | "dirty_lens"
  | "disabled_by_default"
  | "disabled_visible"
  | "disc_full"
  | "discover_tune"
  | "dishwasher"
  | "dishwasher_gen"
  | "display_external_input"
  | "display_settings"
  | "distance"
  | "diversity_1"
  | "diversity_2"
  | "diversity_3"
  | "diversity_4"
  | "dns"
  | "do_not_disturb_off"
  | "do_not_disturb_on"
  | "do_not_disturb_on_total_silence"
  | "do_not_step"
  | "do_not_touch"
  | "dock"
  | "dock_to_bottom"
  | "dock_to_left"
  | "dock_to_right"
  | "docs"
  | "docs_add_on"
  | "docs_apps_script"
  | "document_scanner"
  | "document_search"
  | "domain"
  | "domain_add"
  | "domain_disabled"
  | "domain_verification"
  | "domain_verification_off"
  | "domino_mask"
  | "done_all"
  | "done_outline"
  | "donut_large"
  | "donut_small"
  | "door_back"
  | "door_front"
  | "door_open"
  | "door_sensor"
  | "door_sliding"
  | "doorbell"
  | "doorbell_3p"
  | "doorbell_chime"
  | "double_arrow"
  | "downhill_skiing"
  | "download"
  | "download_2"
  | "download_done"
  | "download_for_offline"
  | "downloading"
  | "draft"
  | "draft_orders"
  | "drafts"
  | "drag_click"
  | "drag_handle"
  | "drag_indicator"
  | "drag_pan"
  | "draw"
  | "draw_abstract"
  | "draw_collage"
  | "dresser"
  | "drive_export"
  | "drive_file_move"
  | "drive_folder_upload"
  | "dropdown"
  | "dropper_eye"
  | "dry"
  | "dry_cleaning"
  | "dual_screen"
  | "duo"
  | "dvr"
  | "dynamic_feed"
  | "dynamic_form"
  | "e911_avatar"
  | "e911_emergency"
  | "e_mobiledata"
  | "e_mobiledata_badge"
  | "ear_sound"
  | "earbud_case"
  | "earbud_left"
  | "earbud_right"
  | "earbuds"
  | "earbuds_2"
  | "earbuds_battery"
  | "early_on"
  | "earthquake"
  | "east"
  | "ecg"
  | "ecg_heart"
  | "eco"
  | "eda"
  | "edgesensor_high"
  | "edgesensor_low"
  | "edit"
  | "edit_arrow_down"
  | "edit_arrow_up"
  | "edit_attributes"
  | "edit_audio"
  | "edit_calendar"
  | "edit_document"
  | "edit_location"
  | "edit_location_alt"
  | "edit_note"
  | "edit_notifications"
  | "edit_off"
  | "edit_road"
  | "edit_square"
  | "editor_choice"
  | "egg"
  | "egg_alt"
  | "eject"
  | "elderly"
  | "elderly_woman"
  | "electric_bike"
  | "electric_bolt"
  | "electric_car"
  | "electric_meter"
  | "electric_moped"
  | "electric_rickshaw"
  | "electric_scooter"
  | "electrical_services"
  | "elevation"
  | "elevator"
  | "emergency"
  | "emergency_heat"
  | "emergency_heat_2"
  | "emergency_home"
  | "emergency_recording"
  | "emergency_share"
  | "emergency_share_off"
  | "emoji_events"
  | "emoji_food_beverage"
  | "emoji_language"
  | "emoji_nature"
  | "emoji_objects"
  | "emoji_people"
  | "emoji_symbols"
  | "emoji_transportation"
  | "emoticon"
  | "empty_dashboard"
  | "enable"
  | "encrypted"
  | "encrypted_add"
  | "encrypted_add_circle"
  | "encrypted_minus_circle"
  | "encrypted_off"
  | "endocrinology"
  | "energy"
  | "energy_program_saving"
  | "energy_program_time_used"
  | "energy_savings_leaf"
  | "engineering"
  | "enhanced_encryption"
  | "ent"
  | "enterprise"
  | "enterprise_off"
  | "equal"
  | "equalizer"
  | "eraser_size_1"
  | "eraser_size_2"
  | "eraser_size_3"
  | "eraser_size_4"
  | "eraser_size_5"
  | "error"
  | "error_med"
  | "escalator"
  | "escalator_warning"
  | "euro"
  | "euro_symbol"
  | "ev_mobiledata_badge"
  | "ev_shadow"
  | "ev_shadow_add"
  | "ev_shadow_minus"
  | "ev_station"
  | "event"
  | "event_available"
  | "event_busy"
  | "event_list"
  | "event_note"
  | "event_repeat"
  | "event_seat"
  | "event_upcoming"
  | "exclamation"
  | "exercise"
  | "exit_to_app"
  | "expand"
  | "expand_all"
  | "expand_circle_down"
  | "expand_circle_right"
  | "expand_circle_up"
  | "expand_content"
  | "expansion_panels"
  | "experiment"
  | "explicit"
  | "explore"
  | "explore_nearby"
  | "explore_off"
  | "explosion"
  | "export_notes"
  | "exposure"
  | "exposure_neg_1"
  | "exposure_neg_2"
  | "exposure_plus_1"
  | "exposure_plus_2"
  | "exposure_zero"
  | "extension"
  | "extension_off"
  | "eye_tracking"
  | "eyeglasses"
  | "face"
  | "face_2"
  | "face_3"
  | "face_4"
  | "face_5"
  | "face_6"
  | "face_down"
  | "face_left"
  | "face_nod"
  | "face_retouching_off"
  | "face_right"
  | "face_shake"
  | "face_up"
  | "fact_check"
  | "factory"
  | "falling"
  | "familiar_face_and_zone"
  | "family_history"
  | "family_home"
  | "family_link"
  | "family_restroom"
  | "family_star"
  | "fan_focus"
  | "fan_indirect"
  | "farsight_digital"
  | "fast_forward"
  | "fast_rewind"
  | "fastfood"
  | "faucet"
  | "favorite"
  | "fax"
  | "feature_search"
  | "featured_play_list"
  | "featured_seasonal_and_gifts"
  | "featured_video"
  | "feedback"
  | "female"
  | "femur"
  | "femur_alt"
  | "fence"
  | "fertile"
  | "festival"
  | "fiber_dvr"
  | "fiber_manual_record"
  | "fiber_new"
  | "fiber_pin"
  | "fiber_smart_record"
  | "file_copy"
  | "file_copy_off"
  | "file_download_off"
  | "file_export"
  | "file_json"
  | "file_map"
  | "file_map_stack"
  | "file_open"
  | "file_png"
  | "file_present"
  | "file_save"
  | "file_save_off"
  | "file_upload_off"
  | "files"
  | "filter"
  | "filter_1"
  | "filter_2"
  | "filter_3"
  | "filter_4"
  | "filter_5"
  | "filter_6"
  | "filter_7"
  | "filter_8"
  | "filter_9"
  | "filter_9_plus"
  | "filter_alt"
  | "filter_alt_off"
  | "filter_arrow_right"
  | "filter_b_and_w"
  | "filter_center_focus"
  | "filter_drama"
  | "filter_frames"
  | "filter_hdr"
  | "filter_list"
  | "filter_list_off"
  | "filter_none"
  | "filter_retrolux"
  | "filter_tilt_shift"
  | "filter_vintage"
  | "finance"
  | "finance_chip"
  | "finance_mode"
  | "find_in_page"
  | "find_replace"
  | "fingerprint"
  | "fingerprint_off"
  | "fire_extinguisher"
  | "fire_hydrant"
  | "fire_truck"
  | "fireplace"
  | "first_page"
  | "fit_page"
  | "fit_page_height"
  | "fit_page_width"
  | "fit_screen"
  | "fit_width"
  | "fitness_center"
  | "fitness_tracker"
  | "flag"
  | "flag_2"
  | "flag_check"
  | "flag_circle"
  | "flaky"
  | "flare"
  | "flash_auto"
  | "flash_off"
  | "flash_on"
  | "flashlight_off"
  | "flashlight_on"
  | "flatware"
  | "flex_direction"
  | "flex_no_wrap"
  | "flex_wrap"
  | "flight"
  | "flight_class"
  | "flight_land"
  | "flight_takeoff"
  | "flights_and_hotels"
  | "flip"
  | "flip_camera_android"
  | "flip_camera_ios"
  | "flip_to_back"
  | "flip_to_front"
  | "float_landscape_2"
  | "float_portrait_2"
  | "flood"
  | "floor"
  | "floor_lamp"
  | "flowchart"
  | "flowsheet"
  | "fluid"
  | "fluid_balance"
  | "fluid_med"
  | "fluorescent"
  | "flutter"
  | "flutter_dash"
  | "flyover"
  | "fmd_bad"
  | "foggy"
  | "folded_hands"
  | "folder"
  | "folder_check"
  | "folder_check_2"
  | "folder_code"
  | "folder_copy"
  | "folder_data"
  | "folder_delete"
  | "folder_eye"
  | "folder_info"
  | "folder_limited"
  | "folder_managed"
  | "folder_match"
  | "folder_off"
  | "folder_open"
  | "folder_shared"
  | "folder_special"
  | "folder_supervised"
  | "folder_zip"
  | "follow_the_signs"
  | "font_download"
  | "font_download_off"
  | "food_bank"
  | "foot_bones"
  | "footprint"
  | "for_you"
  | "forest"
  | "fork_left"
  | "fork_right"
  | "fork_spoon"
  | "forklift"
  | "format_align_center"
  | "format_align_justify"
  | "format_align_left"
  | "format_align_right"
  | "format_bold"
  | "format_clear"
  | "format_color_fill"
  | "format_color_reset"
  | "format_color_text"
  | "format_h1"
  | "format_h2"
  | "format_h3"
  | "format_h4"
  | "format_h5"
  | "format_h6"
  | "format_image_left"
  | "format_image_right"
  | "format_indent_decrease"
  | "format_indent_increase"
  | "format_ink_highlighter"
  | "format_italic"
  | "format_letter_spacing"
  | "format_letter_spacing_2"
  | "format_letter_spacing_standard"
  | "format_letter_spacing_wide"
  | "format_letter_spacing_wider"
  | "format_line_spacing"
  | "format_list_bulleted"
  | "format_list_bulleted_add"
  | "format_list_numbered"
  | "format_list_numbered_rtl"
  | "format_overline"
  | "format_paint"
  | "format_paragraph"
  | "format_quote"
  | "format_quote_off"
  | "format_shapes"
  | "format_size"
  | "format_strikethrough"
  | "format_text_clip"
  | "format_text_overflow"
  | "format_text_wrap"
  | "format_textdirection_l_to_r"
  | "format_textdirection_r_to_l"
  | "format_textdirection_vertical"
  | "format_underlined"
  | "format_underlined_squiggle"
  | "forms_add_on"
  | "forms_apps_script"
  | "fort"
  | "forum"
  | "forward"
  | "forward_10"
  | "forward_30"
  | "forward_5"
  | "forward_circle"
  | "forward_media"
  | "forward_to_inbox"
  | "foundation"
  | "fragrance"
  | "frame_inspect"
  | "frame_person"
  | "frame_person_mic"
  | "frame_person_off"
  | "frame_reload"
  | "frame_source"
  | "free_cancellation"
  | "front_hand"
  | "front_loader"
  | "full_coverage"
  | "full_hd"
  | "full_stacked_bar_chart"
  | "fullscreen"
  | "fullscreen_exit"
  | "fullscreen_portrait"
  | "function"
  | "functions"
  | "funicular"
  | "g_mobiledata"
  | "g_mobiledata_badge"
  | "g_translate"
  | "gallery_thumbnail"
  | "gamepad"
  | "garage"
  | "garage_door"
  | "garage_home"
  | "garden_cart"
  | "gas_meter"
  | "gastroenterology"
  | "gate"
  | "gavel"
  | "general_device"
  | "genetics"
  | "genres"
  | "gesture"
  | "gesture_select"
  | "gif"
  | "gif_2"
  | "gif_box"
  | "girl"
  | "gite"
  | "glass_cup"
  | "globe"
  | "globe_asia"
  | "globe_book"
  | "globe_location_pin"
  | "globe_uk"
  | "glucose"
  | "glyphs"
  | "go_to_line"
  | "golf_course"
  | "gondola_lift"
  | "google_home_devices"
  | "google_tv_remote"
  | "google_wifi"
  | "gpp_bad"
  | "gpp_maybe"
  | "gradient"
  | "grading"
  | "grain"
  | "graph_1"
  | "graph_2"
  | "graph_3"
  | "graph_4"
  | "graph_5"
  | "graph_6"
  | "graph_7"
  | "graphic_eq"
  | "grass"
  | "grid_3x3"
  | "grid_3x3_off"
  | "grid_4x4"
  | "grid_goldenratio"
  | "grid_guides"
  | "grid_off"
  | "grid_on"
  | "grid_view"
  | "grocery"
  | "group"
  | "group_add"
  | "group_off"
  | "group_remove"
  | "group_search"
  | "group_work"
  | "grouped_bar_chart"
  | "groups"
  | "groups_2"
  | "groups_3"
  | "guardian"
  | "gynecology"
  | "h_mobiledata"
  | "h_mobiledata_badge"
  | "h_plus_mobiledata"
  | "h_plus_mobiledata_badge"
  | "hail"
  | "hallway"
  | "hand_bones"
  | "hand_gesture"
  | "hand_gesture_off"
  | "handheld_controller"
  | "handshake"
  | "handyman"
  | "hangout_video"
  | "hangout_video_off"
  | "hard_disk"
  | "hard_drive"
  | "hard_drive_2"
  | "hardware"
  | "hd"
  | "hdr_auto"
  | "hdr_auto_select"
  | "hdr_enhanced_select"
  | "hdr_off"
  | "hdr_off_select"
  | "hdr_on"
  | "hdr_on_select"
  | "hdr_plus"
  | "hdr_plus_off"
  | "hdr_strong"
  | "hdr_weak"
  | "head_mounted_device"
  | "headphones"
  | "headphones_battery"
  | "headset_mic"
  | "headset_off"
  | "healing"
  | "health_and_beauty"
  | "health_and_safety"
  | "health_metrics"
  | "heap_snapshot_large"
  | "heap_snapshot_multiple"
  | "heap_snapshot_thumbnail"
  | "hearing"
  | "hearing_aid"
  | "hearing_aid_disabled"
  | "hearing_disabled"
  | "heart_broken"
  | "heart_check"
  | "heart_minus"
  | "heart_plus"
  | "heat"
  | "heat_pump"
  | "heat_pump_balance"
  | "height"
  | "helicopter"
  | "help"
  | "help_center"
  | "help_clinic"
  | "hematology"
  | "hevc"
  | "hexagon"
  | "hide"
  | "hide_image"
  | "hide_source"
  | "high_density"
  | "high_quality"
  | "high_res"
  | "highlight"
  | "highlight_keyboard_focus"
  | "highlight_mouse_cursor"
  | "highlight_text_cursor"
  | "highlighter_size_1"
  | "highlighter_size_2"
  | "highlighter_size_3"
  | "highlighter_size_4"
  | "highlighter_size_5"
  | "hiking"
  | "history"
  | "history_2"
  | "history_edu"
  | "history_off"
  | "history_toggle_off"
  | "hive"
  | "hls"
  | "hls_off"
  | "holiday_village"
  | "home"
  | "home_and_garden"
  | "home_app_logo"
  | "home_health"
  | "home_improvement_and_tools"
  | "home_iot_device"
  | "home_max"
  | "home_max_dots"
  | "home_mini"
  | "home_pin"
  | "home_repair_service"
  | "home_speaker"
  | "home_storage"
  | "home_work"
  | "horizontal_distribute"
  | "horizontal_rule"
  | "horizontal_split"
  | "host"
  | "hot_tub"
  | "hotel"
  | "hotel_class"
  | "hourglass"
  | "hourglass_arrow_down"
  | "hourglass_arrow_up"
  | "hourglass_bottom"
  | "hourglass_disabled"
  | "hourglass_empty"
  | "hourglass_pause"
  | "hourglass_top"
  | "house"
  | "house_siding"
  | "house_with_shield"
  | "houseboat"
  | "household_supplies"
  | "hov"
  | "how_to_reg"
  | "how_to_vote"
  | "hr_resting"
  | "html"
  | "http"
  | "hub"
  | "humerus"
  | "humerus_alt"
  | "humidity_high"
  | "humidity_indoor"
  | "humidity_low"
  | "humidity_mid"
  | "humidity_percentage"
  | "hvac"
  | "hvac_max_defrost"
  | "ice_skating"
  | "icecream"
  | "id_card"
  | "identity_aware_proxy"
  | "identity_platform"
  | "ifl"
  | "iframe"
  | "iframe_off"
  | "image"
  | "image_arrow_up"
  | "image_aspect_ratio"
  | "image_search"
  | "imagesearch_roller"
  | "imagesmode"
  | "immunology"
  | "import_contacts"
  | "important_devices"
  | "in_home_mode"
  | "inactive_order"
  | "inbox"
  | "inbox_customize"
  | "inbox_text"
  | "inbox_text_asterisk"
  | "inbox_text_person"
  | "inbox_text_share"
  | "incomplete_circle"
  | "indeterminate_check_box"
  | "indeterminate_question_box"
  | "info"
  | "info_i"
  | "infrared"
  | "ink_eraser"
  | "ink_eraser_off"
  | "ink_highlighter"
  | "ink_highlighter_move"
  | "ink_marker"
  | "ink_pen"
  | "ink_selection"
  | "inpatient"
  | "input"
  | "input_circle"
  | "insert_chart"
  | "insert_page_break"
  | "insert_text"
  | "install_desktop"
  | "install_mobile"
  | "instant_mix"
  | "integration_instructions"
  | "interactive_space"
  | "interests"
  | "interpreter_mode"
  | "inventory"
  | "inventory_2"
  | "invert_colors"
  | "invert_colors_off"
  | "ios"
  | "ios_share"
  | "iron"
  | "jamboard_kiosk"
  | "javascript"
  | "join"
  | "join_inner"
  | "join_left"
  | "join_right"
  | "joystick"
  | "jump_to_element"
  | "kayaking"
  | "kebab_dining"
  | "keep"
  | "keep_off"
  | "keep_public"
  | "kettle"
  | "key"
  | "key_off"
  | "key_vertical"
  | "key_visualizer"
  | "keyboard"
  | "keyboard_alt"
  | "keyboard_arrow_down"
  | "keyboard_arrow_left"
  | "keyboard_arrow_right"
  | "keyboard_arrow_up"
  | "keyboard_backspace"
  | "keyboard_capslock"
  | "keyboard_capslock_badge"
  | "keyboard_command_key"
  | "keyboard_control_key"
  | "keyboard_double_arrow_down"
  | "keyboard_double_arrow_left"
  | "keyboard_double_arrow_right"
  | "keyboard_double_arrow_up"
  | "keyboard_external_input"
  | "keyboard_full"
  | "keyboard_hide"
  | "keyboard_keys"
  | "keyboard_lock"
  | "keyboard_lock_off"
  | "keyboard_off"
  | "keyboard_onscreen"
  | "keyboard_option_key"
  | "keyboard_previous_language"
  | "keyboard_return"
  | "keyboard_tab"
  | "keyboard_tab_rtl"
  | "kid_star"
  | "king_bed"
  | "kitchen"
  | "kitesurfing"
  | "lab_panel"
  | "lab_profile"
  | "lab_research"
  | "label"
  | "label_important"
  | "label_off"
  | "labs"
  | "lan"
  | "landscape"
  | "landscape_2"
  | "landscape_2_off"
  | "landslide"
  | "language"
  | "language_chinese_array"
  | "language_chinese_cangjie"
  | "language_chinese_dayi"
  | "language_chinese_pinyin"
  | "language_chinese_quick"
  | "language_chinese_wubi"
  | "language_french"
  | "language_gb_english"
  | "language_international"
  | "language_japanese_kana"
  | "language_korean_latin"
  | "language_pinyin"
  | "language_spanish"
  | "language_us"
  | "language_us_colemak"
  | "language_us_dvorak"
  | "laps"
  | "laptop_car"
  | "laptop_chromebook"
  | "laptop_mac"
  | "laptop_windows"
  | "lasso_select"
  | "last_page"
  | "laundry"
  | "layers"
  | "layers_clear"
  | "lda"
  | "leaderboard"
  | "leak_add"
  | "leak_remove"
  | "left_click"
  | "left_panel_close"
  | "left_panel_open"
  | "legend_toggle"
  | "lens_blur"
  | "letter_switch"
  | "library_add"
  | "library_add_check"
  | "library_books"
  | "library_music"
  | "license"
  | "lift_to_talk"
  | "light"
  | "light_group"
  | "light_mode"
  | "light_off"
  | "lightbulb"
  | "lightbulb_2"
  | "lightbulb_circle"
  | "lightning_stand"
  | "line_axis"
  | "line_curve"
  | "line_end"
  | "line_end_arrow"
  | "line_end_arrow_notch"
  | "line_end_circle"
  | "line_end_diamond"
  | "line_end_square"
  | "line_start"
  | "line_start_arrow"
  | "line_start_arrow_notch"
  | "line_start_circle"
  | "line_start_diamond"
  | "line_start_square"
  | "line_style"
  | "line_weight"
  | "linear_scale"
  | "link"
  | "link_off"
  | "linked_camera"
  | "linked_services"
  | "liquor"
  | "list"
  | "list_alt"
  | "list_alt_add"
  | "list_alt_check"
  | "lists"
  | "live_help"
  | "live_tv"
  | "living"
  | "local_activity"
  | "local_atm"
  | "local_bar"
  | "local_cafe"
  | "local_car_wash"
  | "local_convenience_store"
  | "local_dining"
  | "local_drink"
  | "local_fire_department"
  | "local_florist"
  | "local_gas_station"
  | "local_hospital"
  | "local_laundry_service"
  | "local_library"
  | "local_mall"
  | "local_parking"
  | "local_pharmacy"
  | "local_pizza"
  | "local_police"
  | "local_post_office"
  | "local_see"
  | "local_shipping"
  | "local_taxi"
  | "location_away"
  | "location_chip"
  | "location_city"
  | "location_disabled"
  | "location_home"
  | "location_off"
  | "location_on"
  | "location_searching"
  | "lock"
  | "lock_clock"
  | "lock_open"
  | "lock_open_circle"
  | "lock_open_right"
  | "lock_person"
  | "lock_reset"
  | "login"
  | "logo_dev"
  | "logout"
  | "looks"
  | "looks_3"
  | "looks_4"
  | "looks_5"
  | "looks_6"
  | "looks_one"
  | "looks_two"
  | "loupe"
  | "low_density"
  | "low_priority"
  | "lowercase"
  | "loyalty"
  | "lte_mobiledata"
  | "lte_mobiledata_badge"
  | "lte_plus_mobiledata"
  | "lte_plus_mobiledata_badge"
  | "luggage"
  | "lunch_dining"
  | "lyrics"
  | "macro_auto"
  | "macro_off"
  | "magnification_large"
  | "magnification_small"
  | "magnify_docked"
  | "magnify_fullscreen"
  | "mail"
  | "mail_lock"
  | "mail_off"
  | "male"
  | "man"
  | "man_2"
  | "man_3"
  | "man_4"
  | "manage_accounts"
  | "manage_history"
  | "manage_search"
  | "manga"
  | "manufacturing"
  | "map"
  | "map_search"
  | "maps_ugc"
  | "margin"
  | "mark_as_unread"
  | "mark_chat_read"
  | "mark_chat_unread"
  | "mark_email_read"
  | "mark_email_unread"
  | "mark_unread_chat_alt"
  | "markdown"
  | "markdown_copy"
  | "markdown_paste"
  | "markunread_mailbox"
  | "masked_transitions"
  | "masked_transitions_add"
  | "masks"
  | "match_case"
  | "match_case_off"
  | "match_word"
  | "matter"
  | "maximize"
  | "measuring_tape"
  | "media_bluetooth_off"
  | "media_bluetooth_on"
  | "media_link"
  | "media_output"
  | "media_output_off"
  | "mediation"
  | "medical_information"
  | "medical_mask"
  | "medical_services"
  | "medication"
  | "medication_liquid"
  | "meeting_room"
  | "memory"
  | "memory_alt"
  | "menstrual_health"
  | "menu"
  | "menu_book"
  | "menu_open"
  | "merge"
  | "merge_type"
  | "metabolism"
  | "metro"
  | "mfg_nest_yale_lock"
  | "mic"
  | "mic_alert"
  | "mic_double"
  | "mic_external_off"
  | "mic_external_on"
  | "mic_off"
  | "microbiology"
  | "microwave"
  | "microwave_gen"
  | "military_tech"
  | "mimo"
  | "mimo_disconnect"
  | "mindfulness"
  | "minimize"
  | "minor_crash"
  | "mintmark"
  | "missed_video_call"
  | "missing_controller"
  | "mist"
  | "mitre"
  | "mixture_med"
  | "mms"
  | "mobile_friendly"
  | "mobile_hand"
  | "mobile_loupe"
  | "mobile_off"
  | "mobile_screen_share"
  | "mobile_screensaver"
  | "mobile_sound_2"
  | "mobile_speaker"
  | "mobiledata_off"
  | "mode_comment"
  | "mode_cool"
  | "mode_cool_off"
  | "mode_dual"
  | "mode_fan"
  | "mode_fan_off"
  | "mode_heat"
  | "mode_heat_cool"
  | "mode_heat_off"
  | "mode_night"
  | "mode_of_travel"
  | "mode_off_on"
  | "mode_standby"
  | "model_training"
  | "modeling"
  | "money"
  | "money_bag"
  | "money_off"
  | "monitor"
  | "monitor_heart"
  | "monitor_weight"
  | "monitor_weight_gain"
  | "monitor_weight_loss"
  | "monitoring"
  | "monochrome_photos"
  | "monorail"
  | "mood"
  | "mood_bad"
  | "moon_stars"
  | "mop"
  | "moped"
  | "more"
  | "more_down"
  | "more_horiz"
  | "more_time"
  | "more_up"
  | "more_vert"
  | "mosque"
  | "motion_blur"
  | "motion_mode"
  | "motion_photos_auto"
  | "motion_photos_off"
  | "motion_photos_on"
  | "motion_photos_paused"
  | "motion_play"
  | "motion_sensor_active"
  | "motion_sensor_alert"
  | "motion_sensor_idle"
  | "motion_sensor_urgent"
  | "motorcycle"
  | "mountain_flag"
  | "mouse"
  | "mouse_lock"
  | "mouse_lock_off"
  | "move"
  | "move_down"
  | "move_group"
  | "move_item"
  | "move_location"
  | "move_selection_down"
  | "move_selection_left"
  | "move_selection_right"
  | "move_selection_up"
  | "move_to_inbox"
  | "move_up"
  | "moved_location"
  | "movie"
  | "movie_edit"
  | "movie_info"
  | "movie_off"
  | "moving"
  | "moving_beds"
  | "moving_ministry"
  | "mp"
  | "multicooker"
  | "multiline_chart"
  | "multimodal_hand_eye"
  | "multiple_airports"
  | "multiple_stop"
  | "museum"
  | "music_cast"
  | "music_note"
  | "music_note_add"
  | "music_off"
  | "music_video"
  | "my_location"
  | "mystery"
  | "nat"
  | "nature"
  | "nature_people"
  | "navigation"
  | "near_me"
  | "near_me_disabled"
  | "nearby"
  | "nearby_error"
  | "nearby_off"
  | "nephrology"
  | "nest_audio"
  | "nest_cam_floodlight"
  | "nest_cam_indoor"
  | "nest_cam_iq"
  | "nest_cam_iq_outdoor"
  | "nest_cam_magnet_mount"
  | "nest_cam_outdoor"
  | "nest_cam_stand"
  | "nest_cam_wall_mount"
  | "nest_cam_wired_stand"
  | "nest_clock_farsight_analog"
  | "nest_clock_farsight_digital"
  | "nest_connect"
  | "nest_detect"
  | "nest_display"
  | "nest_display_max"
  | "nest_doorbell_visitor"
  | "nest_eco_leaf"
  | "nest_farsight_weather"
  | "nest_found_savings"
  | "nest_heat_link_e"
  | "nest_heat_link_gen_3"
  | "nest_hello_doorbell"
  | "nest_mini"
  | "nest_multi_room"
  | "nest_protect"
  | "nest_remote"
  | "nest_remote_comfort_sensor"
  | "nest_secure_alarm"
  | "nest_sunblock"
  | "nest_tag"
  | "nest_thermostat"
  | "nest_thermostat_e_eu"
  | "nest_thermostat_gen_3"
  | "nest_thermostat_sensor"
  | "nest_thermostat_sensor_eu"
  | "nest_thermostat_zirconium_eu"
  | "nest_true_radiant"
  | "nest_wake_on_approach"
  | "nest_wake_on_press"
  | "nest_wifi_point"
  | "nest_wifi_pro"
  | "nest_wifi_pro_2"
  | "nest_wifi_router"
  | "network_cell"
  | "network_check"
  | "network_intel_node"
  | "network_intelligence"
  | "network_intelligence_history"
  | "network_intelligence_update"
  | "network_locked"
  | "network_manage"
  | "network_node"
  | "network_ping"
  | "network_wifi"
  | "network_wifi_1_bar"
  | "network_wifi_1_bar_locked"
  | "network_wifi_2_bar"
  | "network_wifi_2_bar_locked"
  | "network_wifi_3_bar"
  | "network_wifi_3_bar_locked"
  | "network_wifi_locked"
  | "neurology"
  | "new_label"
  | "new_releases"
  | "new_window"
  | "news"
  | "newsmode"
  | "newspaper"
  | "newsstand"
  | "next_plan"
  | "next_week"
  | "nfc"
  | "nfc_off"
  | "night_shelter"
  | "night_sight_auto"
  | "night_sight_auto_off"
  | "night_sight_max"
  | "nightlife"
  | "nightlight"
  | "nights_stay"
  | "no_accounts"
  | "no_adult_content"
  | "no_backpack"
  | "no_crash"
  | "no_drinks"
  | "no_encryption"
  | "no_flash"
  | "no_food"
  | "no_luggage"
  | "no_meals"
  | "no_meeting_room"
  | "no_photography"
  | "no_sim"
  | "no_sound"
  | "no_stroller"
  | "no_transfer"
  | "noise_aware"
  | "noise_control_off"
  | "noise_control_on"
  | "nordic_walking"
  | "north"
  | "north_east"
  | "north_west"
  | "not_accessible"
  | "not_accessible_forward"
  | "not_listed_location"
  | "not_started"
  | "note_add"
  | "note_alt"
  | "note_stack"
  | "note_stack_add"
  | "notes"
  | "notification_add"
  | "notification_important"
  | "notification_multiple"
  | "notification_settings"
  | "notification_sound"
  | "notifications"
  | "notifications_active"
  | "notifications_off"
  | "notifications_paused"
  | "notifications_unread"
  | "numbers"
  | "nutrition"
  | "ods"
  | "odt"
  | "offline_bolt"
  | "offline_pin"
  | "offline_pin_off"
  | "offline_share"
  | "oil_barrel"
  | "on_device_training"
  | "on_hub_device"
  | "oncology"
  | "online_prediction"
  | "onsen"
  | "opacity"
  | "open_in_browser"
  | "open_in_full"
  | "open_in_new"
  | "open_in_new_down"
  | "open_in_new_off"
  | "open_in_phone"
  | "open_jam"
  | "open_run"
  | "open_with"
  | "ophthalmology"
  | "oral_disease"
  | "orbit"
  | "order_approve"
  | "order_play"
  | "orders"
  | "orthopedics"
  | "other_admission"
  | "other_houses"
  | "outbound"
  | "outbox"
  | "outbox_alt"
  | "outdoor_garden"
  | "outdoor_grill"
  | "outgoing_mail"
  | "outlet"
  | "outpatient"
  | "outpatient_med"
  | "output"
  | "output_circle"
  | "oven"
  | "oven_gen"
  | "overview"
  | "overview_key"
  | "owl"
  | "oxygen_saturation"
  | "p2p"
  | "pace"
  | "pacemaker"
  | "package"
  | "package_2"
  | "padding"
  | "page_control"
  | "page_footer"
  | "page_header"
  | "page_info"
  | "pageless"
  | "pages"
  | "pageview"
  | "paid"
  | "palette"
  | "pallet"
  | "pan_tool"
  | "pan_tool_alt"
  | "pan_zoom"
  | "panorama"
  | "panorama_horizontal"
  | "panorama_photosphere"
  | "panorama_vertical"
  | "panorama_wide_angle"
  | "paragliding"
  | "park"
  | "partly_cloudy_day"
  | "partly_cloudy_night"
  | "partner_exchange"
  | "partner_reports"
  | "party_mode"
  | "passkey"
  | "password"
  | "password_2"
  | "password_2_off"
  | "patient_list"
  | "pattern"
  | "pause"
  | "pause_circle"
  | "pause_presentation"
  | "payments"
  | "pedal_bike"
  | "pediatrics"
  | "pen_size_1"
  | "pen_size_2"
  | "pen_size_3"
  | "pen_size_4"
  | "pen_size_5"
  | "pending"
  | "pending_actions"
  | "pentagon"
  | "percent"
  | "pergola"
  | "perm_camera_mic"
  | "perm_contact_calendar"
  | "perm_data_setting"
  | "perm_device_information"
  | "perm_media"
  | "perm_phone_msg"
  | "perm_scan_wifi"
  | "person"
  | "person_2"
  | "person_3"
  | "person_4"
  | "person_add"
  | "person_add_disabled"
  | "person_alert"
  | "person_apron"
  | "person_book"
  | "person_cancel"
  | "person_celebrate"
  | "person_check"
  | "person_edit"
  | "person_off"
  | "person_pin"
  | "person_pin_circle"
  | "person_play"
  | "person_raised_hand"
  | "person_remove"
  | "person_search"
  | "person_shield"
  | "personal_bag"
  | "personal_bag_off"
  | "personal_bag_question"
  | "personal_injury"
  | "personal_places"
  | "pest_control"
  | "pest_control_rodent"
  | "pet_supplies"
  | "pets"
  | "phishing"
  | "phone_android"
  | "phone_bluetooth_speaker"
  | "phone_callback"
  | "phone_disabled"
  | "phone_enabled"
  | "phone_forwarded"
  | "phone_in_talk"
  | "phone_iphone"
  | "phone_locked"
  | "phone_missed"
  | "phone_paused"
  | "phonelink_erase"
  | "phonelink_lock"
  | "phonelink_off"
  | "phonelink_ring"
  | "phonelink_ring_off"
  | "phonelink_setup"
  | "photo"
  | "photo_album"
  | "photo_auto_merge"
  | "photo_camera"
  | "photo_camera_back"
  | "photo_camera_front"
  | "photo_frame"
  | "photo_library"
  | "photo_prints"
  | "photo_size_select_large"
  | "photo_size_select_small"
  | "php"
  | "physical_therapy"
  | "piano"
  | "piano_off"
  | "picture_as_pdf"
  | "picture_in_picture"
  | "picture_in_picture_alt"
  | "picture_in_picture_center"
  | "picture_in_picture_large"
  | "picture_in_picture_medium"
  | "picture_in_picture_mobile"
  | "picture_in_picture_off"
  | "picture_in_picture_small"
  | "pie_chart"
  | "pill"
  | "pill_off"
  | "pin"
  | "pin_drop"
  | "pin_end"
  | "pin_invoke"
  | "pinboard"
  | "pinboard_unread"
  | "pinch"
  | "pinch_zoom_in"
  | "pinch_zoom_out"
  | "pip"
  | "pip_exit"
  | "pivot_table_chart"
  | "place_item"
  | "plagiarism"
  | "planet"
  | "planner_banner_ad_pt"
  | "planner_review"
  | "play_arrow"
  | "play_circle"
  | "play_disabled"
  | "play_for_work"
  | "play_lesson"
  | "play_pause"
  | "playing_cards"
  | "playlist_add"
  | "playlist_add_check"
  | "playlist_add_check_circle"
  | "playlist_add_circle"
  | "playlist_play"
  | "playlist_remove"
  | "plug_connect"
  | "plumbing"
  | "podcasts"
  | "podiatry"
  | "podium"
  | "point_of_sale"
  | "point_scan"
  | "poker_chip"
  | "policy"
  | "policy_alert"
  | "polyline"
  | "polymer"
  | "pool"
  | "portable_wifi_off"
  | "position_bottom_left"
  | "position_bottom_right"
  | "position_top_right"
  | "post"
  | "post_add"
  | "potted_plant"
  | "power"
  | "power_input"
  | "power_off"
  | "power_settings_circle"
  | "power_settings_new"
  | "prayer_times"
  | "precision_manufacturing"
  | "pregnancy"
  | "pregnant_woman"
  | "preliminary"
  | "prescriptions"
  | "present_to_all"
  | "preview"
  | "preview_off"
  | "price_change"
  | "price_check"
  | "print"
  | "print_add"
  | "print_connect"
  | "print_disabled"
  | "print_error"
  | "print_lock"
  | "priority"
  | "priority_high"
  | "privacy"
  | "privacy_tip"
  | "private_connectivity"
  | "problem"
  | "procedure"
  | "process_chart"
  | "production_quantity_limits"
  | "productivity"
  | "progress_activity"
  | "prompt_suggestion"
  | "propane"
  | "propane_tank"
  | "psychiatry"
  | "psychology"
  | "psychology_alt"
  | "public"
  | "public_off"
  | "publish"
  | "published_with_changes"
  | "pulmonology"
  | "pulse_alert"
  | "punch_clock"
  | "qr_code"
  | "qr_code_2"
  | "qr_code_2_add"
  | "qr_code_scanner"
  | "query_stats"
  | "question_exchange"
  | "question_mark"
  | "queue_music"
  | "queue_play_next"
  | "quick_phrases"
  | "quick_reference"
  | "quick_reference_all"
  | "quick_reorder"
  | "quickreply"
  | "quiz"
  | "r_mobiledata"
  | "radar"
  | "radio"
  | "radio_button_checked"
  | "radio_button_partial"
  | "radio_button_unchecked"
  | "radiology"
  | "railway_alert"
  | "railway_alert_2"
  | "rainy"
  | "rainy_heavy"
  | "rainy_light"
  | "rainy_snow"
  | "ramen_dining"
  | "ramp_left"
  | "ramp_right"
  | "range_hood"
  | "rate_review"
  | "raven"
  | "raw_off"
  | "raw_on"
  | "read_more"
  | "readiness_score"
  | "real_estate_agent"
  | "rear_camera"
  | "rebase"
  | "rebase_edit"
  | "receipt"
  | "receipt_long"
  | "receipt_long_off"
  | "recent_actors"
  | "recent_patient"
  | "recenter"
  | "recommend"
  | "record_voice_over"
  | "rectangle"
  | "recycling"
  | "redeem"
  | "redo"
  | "reduce_capacity"
  | "refresh"
  | "regular_expression"
  | "relax"
  | "release_alert"
  | "remember_me"
  | "reminder"
  | "remote_gen"
  | "remove"
  | "remove_done"
  | "remove_from_queue"
  | "remove_moderator"
  | "remove_road"
  | "remove_selection"
  | "remove_shopping_cart"
  | "reopen_window"
  | "reorder"
  | "repartition"
  | "repeat"
  | "repeat_on"
  | "repeat_one"
  | "repeat_one_on"
  | "replace_audio"
  | "replace_image"
  | "replace_video"
  | "replay"
  | "replay_10"
  | "replay_30"
  | "replay_5"
  | "reply"
  | "reply_all"
  | "report"
  | "report_off"
  | "request_page"
  | "request_quote"
  | "reset_brightness"
  | "reset_focus"
  | "reset_image"
  | "reset_iso"
  | "reset_settings"
  | "reset_shadow"
  | "reset_shutter_speed"
  | "reset_tv"
  | "reset_white_balance"
  | "reset_wrench"
  | "resize"
  | "respiratory_rate"
  | "responsive_layout"
  | "restart_alt"
  | "restaurant"
  | "restore_from_trash"
  | "restore_page"
  | "resume"
  | "reviews"
  | "rewarded_ads"
  | "rheumatology"
  | "rib_cage"
  | "rice_bowl"
  | "right_click"
  | "right_panel_close"
  | "right_panel_open"
  | "ring_volume"
  | "ripples"
  | "road"
  | "robot"
  | "robot_2"
  | "rocket"
  | "rocket_launch"
  | "roller_shades"
  | "roller_shades_closed"
  | "roller_skating"
  | "roofing"
  | "room_preferences"
  | "room_service"
  | "rotate_90_degrees_ccw"
  | "rotate_90_degrees_cw"
  | "rotate_auto"
  | "rotate_left"
  | "rotate_right"
  | "roundabout_left"
  | "roundabout_right"
  | "rounded_corner"
  | "route"
  | "router"
  | "routine"
  | "rowing"
  | "rss_feed"
  | "rsvp"
  | "rtt"
  | "rubric"
  | "rule"
  | "rule_folder"
  | "rule_settings"
  | "run_circle"
  | "running_with_errors"
  | "rv_hookup"
  | "safety_check"
  | "safety_check_off"
  | "safety_divider"
  | "sailing"
  | "salinity"
  | "sanitizer"
  | "satellite"
  | "satellite_alt"
  | "sauna"
  | "save"
  | "save_as"
  | "save_clock"
  | "saved_search"
  | "savings"
  | "scale"
  | "scan"
  | "scan_delete"
  | "scanner"
  | "scatter_plot"
  | "scene"
  | "schedule"
  | "schedule_send"
  | "schema"
  | "school"
  | "science"
  | "science_off"
  | "scooter"
  | "score"
  | "scoreboard"
  | "screen_lock_landscape"
  | "screen_lock_portrait"
  | "screen_lock_rotation"
  | "screen_record"
  | "screen_rotation"
  | "screen_rotation_alt"
  | "screen_rotation_up"
  | "screen_search_desktop"
  | "screen_share"
  | "screenshot"
  | "screenshot_frame"
  | "screenshot_frame_2"
  | "screenshot_keyboard"
  | "screenshot_monitor"
  | "screenshot_region"
  | "screenshot_tablet"
  | "script"
  | "scrollable_header"
  | "scuba_diving"
  | "sd"
  | "sd_card"
  | "sd_card_alert"
  | "sdk"
  | "search"
  | "search_activity"
  | "search_check"
  | "search_check_2"
  | "search_hands_free"
  | "search_insights"
  | "search_off"
  | "seat_cool_left"
  | "seat_cool_right"
  | "seat_heat_left"
  | "seat_heat_right"
  | "seat_vent_left"
  | "seat_vent_right"
  | "security"
  | "security_key"
  | "security_update_good"
  | "security_update_warning"
  | "segment"
  | "select"
  | "select_all"
  | "select_check_box"
  | "select_to_speak"
  | "select_window"
  | "select_window_2"
  | "select_window_off"
  | "self_care"
  | "self_improvement"
  | "sell"
  | "send"
  | "send_and_archive"
  | "send_money"
  | "send_time_extension"
  | "send_to_mobile"
  | "sensor_door"
  | "sensor_occupied"
  | "sensor_window"
  | "sensors"
  | "sensors_krx"
  | "sensors_krx_off"
  | "sensors_off"
  | "sentiment_calm"
  | "sentiment_content"
  | "sentiment_dissatisfied"
  | "sentiment_excited"
  | "sentiment_extremely_dissatisfied"
  | "sentiment_frustrated"
  | "sentiment_neutral"
  | "sentiment_sad"
  | "sentiment_satisfied"
  | "sentiment_stressed"
  | "sentiment_very_dissatisfied"
  | "sentiment_very_satisfied"
  | "sentiment_worried"
  | "serif"
  | "server_person"
  | "service_toolbox"
  | "set_meal"
  | "settings"
  | "settings_accessibility"
  | "settings_account_box"
  | "settings_alert"
  | "settings_applications"
  | "settings_b_roll"
  | "settings_backup_restore"
  | "settings_bluetooth"
  | "settings_brightness"
  | "settings_cell"
  | "settings_cinematic_blur"
  | "settings_ethernet"
  | "settings_heart"
  | "settings_input_antenna"
  | "settings_input_component"
  | "settings_input_hdmi"
  | "settings_input_svideo"
  | "settings_motion_mode"
  | "settings_night_sight"
  | "settings_overscan"
  | "settings_panorama"
  | "settings_phone"
  | "settings_photo_camera"
  | "settings_power"
  | "settings_remote"
  | "settings_slow_motion"
  | "settings_system_daydream"
  | "settings_timelapse"
  | "settings_video_camera"
  | "settings_voice"
  | "settop_component"
  | "severe_cold"
  | "shadow"
  | "shadow_add"
  | "shadow_minus"
  | "shape_line"
  | "shapes"
  | "share"
  | "share_eta"
  | "share_location"
  | "share_off"
  | "share_reviews"
  | "share_windows"
  | "sheets_rtl"
  | "shelf_auto_hide"
  | "shelf_position"
  | "shelves"
  | "shield"
  | "shield_lock"
  | "shield_locked"
  | "shield_moon"
  | "shield_person"
  | "shield_question"
  | "shield_with_heart"
  | "shield_with_house"
  | "shift"
  | "shift_lock"
  | "shift_lock_off"
  | "shop"
  | "shop_two"
  | "shopping_bag"
  | "shopping_bag_speed"
  | "shopping_basket"
  | "shopping_cart"
  | "shopping_cart_checkout"
  | "shopping_cart_off"
  | "shoppingmode"
  | "short_stay"
  | "short_text"
  | "show_chart"
  | "shower"
  | "shuffle"
  | "shuffle_on"
  | "shutter_speed"
  | "shutter_speed_add"
  | "shutter_speed_minus"
  | "sick"
  | "side_navigation"
  | "sign_language"
  | "signal_cellular_0_bar"
  | "signal_cellular_1_bar"
  | "signal_cellular_2_bar"
  | "signal_cellular_3_bar"
  | "signal_cellular_4_bar"
  | "signal_cellular_add"
  | "signal_cellular_alt"
  | "signal_cellular_alt_1_bar"
  | "signal_cellular_alt_2_bar"
  | "signal_cellular_connected_no_internet_0_bar"
  | "signal_cellular_connected_no_internet_4_bar"
  | "signal_cellular_nodata"
  | "signal_cellular_null"
  | "signal_cellular_off"
  | "signal_cellular_pause"
  | "signal_disconnected"
  | "signal_wifi_0_bar"
  | "signal_wifi_4_bar"
  | "signal_wifi_bad"
  | "signal_wifi_off"
  | "signal_wifi_statusbar_not_connected"
  | "signal_wifi_statusbar_null"
  | "signature"
  | "signpost"
  | "sim_card"
  | "sim_card_download"
  | "simulation"
  | "single_bed"
  | "sip"
  | "siren"
  | "siren_check"
  | "siren_open"
  | "siren_question"
  | "skateboarding"
  | "skeleton"
  | "skillet"
  | "skillet_cooktop"
  | "skip_next"
  | "skip_previous"
  | "skull"
  | "skull_list"
  | "slab_serif"
  | "sledding"
  | "sleep_score"
  | "slide_library"
  | "sliders"
  | "slideshow"
  | "slow_motion_video"
  | "smart_card_reader"
  | "smart_card_reader_off"
  | "smart_display"
  | "smart_outlet"
  | "smart_screen"
  | "smart_toy"
  | "smartphone"
  | "smartphone_camera"
  | "smb_share"
  | "smoke_free"
  | "smoking_rooms"
  | "sms"
  | "snippet_folder"
  | "snooze"
  | "snowboarding"
  | "snowing"
  | "snowing_heavy"
  | "snowmobile"
  | "snowshoeing"
  | "soap"
  | "social_distance"
  | "social_leaderboard"
  | "solar_power"
  | "sort"
  | "sort_by_alpha"
  | "sos"
  | "sound_detection_dog_barking"
  | "sound_detection_glass_break"
  | "sound_detection_loud_sound"
  | "sound_sampler"
  | "soup_kitchen"
  | "source_environment"
  | "source_notes"
  | "south"
  | "south_america"
  | "south_east"
  | "south_west"
  | "spa"
  | "space_bar"
  | "space_dashboard"
  | "spatial_audio"
  | "spatial_audio_off"
  | "spatial_speaker"
  | "spatial_tracking"
  | "speaker"
  | "speaker_group"
  | "speaker_notes"
  | "speaker_notes_off"
  | "speaker_phone"
  | "special_character"
  | "specific_gravity"
  | "speech_to_text"
  | "speed"
  | "speed_0_25"
  | "speed_0_2x"
  | "speed_0_5"
  | "speed_0_5x"
  | "speed_0_75"
  | "speed_0_7x"
  | "speed_1_2"
  | "speed_1_25"
  | "speed_1_2x"
  | "speed_1_5"
  | "speed_1_5x"
  | "speed_1_75"
  | "speed_1_7x"
  | "speed_2x"
  | "speed_camera"
  | "spellcheck"
  | "split_scene"
  | "splitscreen"
  | "splitscreen_add"
  | "splitscreen_bottom"
  | "splitscreen_landscape"
  | "splitscreen_left"
  | "splitscreen_portrait"
  | "splitscreen_right"
  | "splitscreen_top"
  | "splitscreen_vertical_add"
  | "spo2"
  | "spoke"
  | "sports"
  | "sports_and_outdoors"
  | "sports_bar"
  | "sports_baseball"
  | "sports_basketball"
  | "sports_cricket"
  | "sports_esports"
  | "sports_football"
  | "sports_golf"
  | "sports_gymnastics"
  | "sports_handball"
  | "sports_hockey"
  | "sports_kabaddi"
  | "sports_martial_arts"
  | "sports_mma"
  | "sports_motorsports"
  | "sports_rugby"
  | "sports_score"
  | "sports_soccer"
  | "sports_tennis"
  | "sports_volleyball"
  | "sprinkler"
  | "sprint"
  | "square"
  | "square_dot"
  | "square_foot"
  | "ssid_chart"
  | "stack"
  | "stack_group"
  | "stack_hexagon"
  | "stack_off"
  | "stack_star"
  | "stacked_bar_chart"
  | "stacked_email"
  | "stacked_inbox"
  | "stacked_line_chart"
  | "stacks"
  | "stadia_controller"
  | "stadium"
  | "stairs"
  | "stairs_2"
  | "star"
  | "star_half"
  | "star_rate"
  | "star_rate_half"
  | "star_shine"
  | "stars"
  | "stars_2"
  | "start"
  | "stat_0"
  | "stat_1"
  | "stat_2"
  | "stat_3"
  | "stat_minus_1"
  | "stat_minus_2"
  | "stat_minus_3"
  | "stay_current_landscape"
  | "stay_current_portrait"
  | "stay_primary_landscape"
  | "stay_primary_portrait"
  | "steering_wheel_heat"
  | "step"
  | "step_into"
  | "step_out"
  | "step_over"
  | "steppers"
  | "steps"
  | "stethoscope"
  | "stethoscope_arrow"
  | "stethoscope_check"
  | "sticky_note"
  | "sticky_note_2"
  | "stock_media"
  | "stockpot"
  | "stop"
  | "stop_circle"
  | "stop_screen_share"
  | "storage"
  | "store"
  | "storefront"
  | "storm"
  | "straight"
  | "straighten"
  | "strategy"
  | "stream"
  | "stream_apps"
  | "streetview"
  | "stress_management"
  | "strikethrough_s"
  | "stroke_full"
  | "stroke_partial"
  | "stroller"
  | "style"
  | "styler"
  | "stylus"
  | "stylus_brush"
  | "stylus_fountain_pen"
  | "stylus_highlighter"
  | "stylus_laser_pointer"
  | "stylus_note"
  | "stylus_pen"
  | "stylus_pencil"
  | "subdirectory_arrow_left"
  | "subdirectory_arrow_right"
  | "subheader"
  | "subject"
  | "subscript"
  | "subscriptions"
  | "subtitles"
  | "subtitles_gear"
  | "subtitles_off"
  | "subway"
  | "summarize"
  | "sunny"
  | "sunny_snowing"
  | "superscript"
  | "supervised_user_circle"
  | "supervised_user_circle_off"
  | "supervisor_account"
  | "support"
  | "support_agent"
  | "surfing"
  | "surgical"
  | "surround_sound"
  | "swap_calls"
  | "swap_driving_apps"
  | "swap_driving_apps_wheel"
  | "swap_horiz"
  | "swap_horizontal_circle"
  | "swap_vert"
  | "swap_vertical_circle"
  | "sweep"
  | "swipe"
  | "swipe_down"
  | "swipe_down_alt"
  | "swipe_left"
  | "swipe_left_alt"
  | "swipe_right"
  | "swipe_right_alt"
  | "swipe_up"
  | "swipe_up_alt"
  | "swipe_vertical"
  | "switch"
  | "switch_access"
  | "switch_access_2"
  | "switch_access_3"
  | "switch_access_shortcut"
  | "switch_access_shortcut_add"
  | "switch_account"
  | "switch_camera"
  | "switch_left"
  | "switch_right"
  | "switch_video"
  | "switches"
  | "sword_rose"
  | "swords"
  | "symptoms"
  | "synagogue"
  | "sync"
  | "sync_alt"
  | "sync_arrow_down"
  | "sync_arrow_up"
  | "sync_desktop"
  | "sync_disabled"
  | "sync_lock"
  | "sync_problem"
  | "sync_saved_locally"
  | "syringe"
  | "system_update"
  | "system_update_alt"
  | "tab"
  | "tab_close"
  | "tab_close_inactive"
  | "tab_close_right"
  | "tab_duplicate"
  | "tab_group"
  | "tab_inactive"
  | "tab_move"
  | "tab_new_right"
  | "tab_recent"
  | "tab_unselected"
  | "table"
  | "table_bar"
  | "table_chart"
  | "table_chart_view"
  | "table_convert"
  | "table_edit"
  | "table_eye"
  | "table_lamp"
  | "table_restaurant"
  | "table_rows"
  | "table_rows_narrow"
  | "table_view"
  | "tablet"
  | "tablet_android"
  | "tablet_camera"
  | "tablet_mac"
  | "tabs"
  | "tactic"
  | "tag"
  | "takeout_dining"
  | "tamper_detection_off"
  | "tamper_detection_on"
  | "tap_and_play"
  | "tapas"
  | "target"
  | "task"
  | "task_alt"
  | "taunt"
  | "taxi_alert"
  | "team_dashboard"
  | "temp_preferences_eco"
  | "temple_buddhist"
  | "temple_hindu"
  | "tenancy"
  | "terminal"
  | "text_ad"
  | "text_compare"
  | "text_decrease"
  | "text_fields"
  | "text_fields_alt"
  | "text_format"
  | "text_increase"
  | "text_rotate_up"
  | "text_rotate_vertical"
  | "text_rotation_angledown"
  | "text_rotation_angleup"
  | "text_rotation_down"
  | "text_rotation_none"
  | "text_select_end"
  | "text_select_jump_to_beginning"
  | "text_select_jump_to_end"
  | "text_select_move_back_character"
  | "text_select_move_back_word"
  | "text_select_move_down"
  | "text_select_move_forward_character"
  | "text_select_move_forward_word"
  | "text_select_move_up"
  | "text_select_start"
  | "text_snippet"
  | "text_to_speech"
  | "text_up"
  | "texture"
  | "texture_add"
  | "texture_minus"
  | "theater_comedy"
  | "theaters"
  | "thermometer"
  | "thermometer_add"
  | "thermometer_gain"
  | "thermometer_loss"
  | "thermometer_minus"
  | "thermostat"
  | "thermostat_arrow_down"
  | "thermostat_arrow_up"
  | "thermostat_auto"
  | "thermostat_carbon"
  | "things_to_do"
  | "thread_unread"
  | "threat_intelligence"
  | "thumb_down"
  | "thumb_up"
  | "thumbnail_bar"
  | "thumbs_up_down"
  | "thunderstorm"
  | "tibia"
  | "tibia_alt"
  | "tile_large"
  | "tile_medium"
  | "tile_small"
  | "time_auto"
  | "timelapse"
  | "timeline"
  | "timer"
  | "timer_10"
  | "timer_10_alt_1"
  | "timer_10_select"
  | "timer_3"
  | "timer_3_alt_1"
  | "timer_3_select"
  | "timer_5"
  | "timer_5_shutter"
  | "timer_arrow_down"
  | "timer_arrow_up"
  | "timer_off"
  | "timer_pause"
  | "timer_play"
  | "tire_repair"
  | "title"
  | "titlecase"
  | "toast"
  | "toc"
  | "today"
  | "toggle_off"
  | "toggle_on"
  | "token"
  | "toll"
  | "tonality"
  | "toolbar"
  | "tools_flat_head"
  | "tools_installation_kit"
  | "tools_ladder"
  | "tools_level"
  | "tools_phillips"
  | "tools_pliers_wire_stripper"
  | "tools_power_drill"
  | "tooltip"
  | "tooltip_2"
  | "top_panel_close"
  | "top_panel_open"
  | "topic"
  | "tornado"
  | "total_dissolved_solids"
  | "touch_app"
  | "touch_double"
  | "touch_long"
  | "touch_triple"
  | "touchpad_mouse"
  | "touchpad_mouse_off"
  | "tour"
  | "toys"
  | "toys_and_games"
  | "toys_fan"
  | "track_changes"
  | "trackpad_input"
  | "trackpad_input_2"
  | "trackpad_input_3"
  | "traffic"
  | "traffic_jam"
  | "trail_length"
  | "trail_length_medium"
  | "trail_length_short"
  | "train"
  | "tram"
  | "transcribe"
  | "transfer_within_a_station"
  | "transform"
  | "transgender"
  | "transit_enterexit"
  | "transit_ticket"
  | "transition_chop"
  | "transition_dissolve"
  | "transition_fade"
  | "transition_push"
  | "transition_slide"
  | "translate"
  | "transportation"
  | "travel"
  | "travel_explore"
  | "travel_luggage_and_bags"
  | "trending_down"
  | "trending_flat"
  | "trending_up"
  | "trip"
  | "trip_origin"
  | "trolley"
  | "trolley_cable_car"
  | "trophy"
  | "troubleshoot"
  | "tsunami"
  | "tsv"
  | "tty"
  | "tune"
  | "turn_left"
  | "turn_right"
  | "turn_sharp_left"
  | "turn_sharp_right"
  | "turn_slight_left"
  | "turn_slight_right"
  | "tv"
  | "tv_displays"
  | "tv_gen"
  | "tv_guide"
  | "tv_next"
  | "tv_off"
  | "tv_options_edit_channels"
  | "tv_options_input_settings"
  | "tv_remote"
  | "tv_signin"
  | "tv_with_assistant"
  | "two_pager"
  | "two_pager_store"
  | "two_wheeler"
  | "type_specimen"
  | "u_turn_left"
  | "u_turn_right"
  | "ulna_radius"
  | "ulna_radius_alt"
  | "umbrella"
  | "unarchive"
  | "undo"
  | "unfold_less"
  | "unfold_less_double"
  | "unfold_more"
  | "unfold_more_double"
  | "ungroup"
  | "universal_currency"
  | "universal_currency_alt"
  | "universal_local"
  | "unknown_2"
  | "unknown_5"
  | "unknown_7"
  | "unknown_document"
  | "unknown_med"
  | "unlicense"
  | "unpaved_road"
  | "unpublished"
  | "unsubscribe"
  | "upcoming"
  | "update"
  | "update_disabled"
  | "upgrade"
  | "upi_pay"
  | "upload"
  | "upload_2"
  | "upload_file"
  | "uppercase"
  | "urology"
  | "usb"
  | "usb_off"
  | "user_attributes"
  | "vaccines"
  | "vacuum"
  | "valve"
  | "vape_free"
  | "vaping_rooms"
  | "variable_add"
  | "variable_insert"
  | "variable_remove"
  | "variables"
  | "ventilator"
  | "verified"
  | "verified_user"
  | "vertical_align_bottom"
  | "vertical_align_center"
  | "vertical_align_top"
  | "vertical_distribute"
  | "vertical_shades"
  | "vertical_shades_closed"
  | "vertical_split"
  | "vibration"
  | "video_call"
  | "video_camera_back"
  | "video_camera_back_add"
  | "video_camera_front"
  | "video_camera_front_off"
  | "video_chat"
  | "video_file"
  | "video_label"
  | "video_library"
  | "video_search"
  | "video_settings"
  | "video_stable"
  | "videocam"
  | "videocam_alert"
  | "videocam_off"
  | "videogame_asset"
  | "videogame_asset_off"
  | "view_agenda"
  | "view_apps"
  | "view_array"
  | "view_carousel"
  | "view_column"
  | "view_column_2"
  | "view_comfy"
  | "view_comfy_alt"
  | "view_compact"
  | "view_compact_alt"
  | "view_cozy"
  | "view_day"
  | "view_headline"
  | "view_in_ar"
  | "view_in_ar_off"
  | "view_kanban"
  | "view_list"
  | "view_module"
  | "view_object_track"
  | "view_quilt"
  | "view_real_size"
  | "view_sidebar"
  | "view_stream"
  | "view_timeline"
  | "view_week"
  | "vignette"
  | "villa"
  | "visibility"
  | "visibility_lock"
  | "visibility_off"
  | "vital_signs"
  | "vo2_max"
  | "voice_chat"
  | "voice_over_off"
  | "voice_selection"
  | "voice_selection_off"
  | "voicemail"
  | "voicemail_2"
  | "volcano"
  | "volume_down"
  | "volume_down_alt"
  | "volume_mute"
  | "volume_off"
  | "volume_up"
  | "volunteer_activism"
  | "voting_chip"
  | "vpn_key"
  | "vpn_key_alert"
  | "vpn_key_off"
  | "vpn_lock"
  | "vpn_lock_2"
  | "vr180_create2d"
  | "vr180_create2d_off"
  | "vrpano"
  | "wall_art"
  | "wall_lamp"
  | "wallet"
  | "wallpaper"
  | "wallpaper_slideshow"
  | "wand_shine"
  | "wand_stars"
  | "ward"
  | "warehouse"
  | "warning"
  | "warning_off"
  | "wash"
  | "watch"
  | "watch_button_press"
  | "watch_check"
  | "watch_off"
  | "watch_screentime"
  | "watch_vibration"
  | "watch_wake"
  | "water"
  | "water_bottle"
  | "water_bottle_large"
  | "water_damage"
  | "water_do"
  | "water_drop"
  | "water_ec"
  | "water_full"
  | "water_heater"
  | "water_lock"
  | "water_loss"
  | "water_lux"
  | "water_medium"
  | "water_orp"
  | "water_ph"
  | "water_pump"
  | "water_voc"
  | "waterfall_chart"
  | "waves"
  | "waving_hand"
  | "wb_auto"
  | "wb_incandescent"
  | "wb_iridescent"
  | "wb_shade"
  | "wb_sunny"
  | "wb_twilight"
  | "wc"
  | "weather_hail"
  | "weather_mix"
  | "weather_snowy"
  | "web"
  | "web_asset"
  | "web_asset_off"
  | "web_stories"
  | "web_traffic"
  | "webhook"
  | "weekend"
  | "weight"
  | "west"
  | "whatshot"
  | "wheelchair_pickup"
  | "where_to_vote"
  | "widget_medium"
  | "widget_small"
  | "widget_width"
  | "widgets"
  | "width_full"
  | "width_normal"
  | "width_wide"
  | "wifi"
  | "wifi_1_bar"
  | "wifi_2_bar"
  | "wifi_add"
  | "wifi_calling"
  | "wifi_calling_bar_1"
  | "wifi_calling_bar_2"
  | "wifi_calling_bar_3"
  | "wifi_channel"
  | "wifi_find"
  | "wifi_home"
  | "wifi_lock"
  | "wifi_notification"
  | "wifi_off"
  | "wifi_password"
  | "wifi_protected_setup"
  | "wifi_proxy"
  | "wifi_tethering"
  | "wifi_tethering_error"
  | "wifi_tethering_off"
  | "wind_power"
  | "window"
  | "window_closed"
  | "window_open"
  | "window_sensor"
  | "windshield_defrost_front"
  | "windshield_defrost_rear"
  | "windshield_heat_front"
  | "wine_bar"
  | "woman"
  | "woman_2"
  | "work"
  | "work_alert"
  | "work_history"
  | "work_update"
  | "workspace_premium"
  | "workspaces"
  | "wounds_injuries"
  | "wrap_text"
  | "wrist"
  | "wrong_location"
  | "wysiwyg"
  | "yard"
  | "your_trips"
  | "youtube_activity"
  | "youtube_searched_for"
  | "zone_person_alert"
  | "zone_person_idle"
  | "zone_person_urgent"
  | "zoom_in"
  | "zoom_in_map"
  | "zoom_out"
  | "zoom_out_map";
